import React from 'react';

const bbkIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>brightback</title>
    <g fill="none" fillRule="evenodd">
      <path fill="#FF75B3" d="M15.114 16.524h-5.038l2.519-4.13z" />
      <path fill="#FF7575" d="M17.633 12.393h-5.038l2.519 4.131z" />
      <path fill="#C76ECC" d="M10.076 16.524H5.038l2.519-4.13z" />
      <path fill="#EB73D5" d="M12.595 12.393H7.557l2.519 4.131z" />
      <path fill="#745185" d="M5.038 16.524H0l2.519-4.13z" />
      <path fill="#9260AB" d="M7.557 12.393H2.519l2.519 4.131z" />
      <path fill="#745185" d="M7.557 12.393H2.519l2.519-4.13z" />
      <path fill="#FF9C75" d="M17.633 12.393h-5.038l2.519-4.13z" />
      <path fill="#FFB575" d="M15.114 8.262h-5.038l2.519 4.131z" />
      <path fill="#5E3799" d="M5.038 8.262H0l2.519-4.13z" />
      <path fill="#425AB8" d="M7.557 4.131H2.519l2.519 4.131z" />
      <path fill="#FFD175" d="M15.114 8.262h-5.038l2.519-4.13z" />
      <path fill="#FFF175" d="M17.633 4.131h-5.038l2.519 4.131z" />
      <path fill="#0E96B8" d="M7.557 4.131H2.519L5.038 0z" />
      <path fill="#A5ED4E" d="M17.633 4.131h-5.038L15.114 0z" />
      <path fill="#0CB07C" d="M10.076 0H5.038l2.519 4.131z" />
      <path fill="#27BA51" d="M12.595 4.131H7.557L10.076 0z" />
      <path fill="#6FD640" d="M15.114 0h-5.038l2.519 4.131z" />
    </g>
  </svg>
);
const icons = {
  account: (
    <svg width="20" height="20">
      <path
        d="M12.942 14.586c-.882-.47-.411-1.353 0-1.764.53-.53 1.177-2.353 1.177-2.353 1.059-.471 1.177-1.235 1.294-1.765.47-1.53-.706-1.764-.706-1.764s.94-2.53.176-4.47c-1-2.53-5.059-3.472-5.765-1.118C4.295.292 5.294 6.938 5.294 6.938s-1.177.235-.706 1.765c.118.53.235 1.294 1.294 1.765 0 0 .648 1.823 1.177 2.352.411.412.882 1.294 0 1.765C5.294 15.526 0 15.762 0 19.88h20c.001-4.117-5.293-4.352-7.058-5.293z"
        fill="#000"
        opacity=".3"
      />
    </svg>
  ),
  // admin: (<svg width="18" height="20"><path d="M.915 3.855a.302.302 0 0 1 .2-.332C3.727 2.37 6.332 1.213 8.93.05c.12-.06.26-.06.379 0 2.613 1.17 5.227 2.33 7.84 3.48a.272.272 0 0 1 .2.295c0 1.78 0 3.563-.01 5.343a11.475 11.475 0 0 1-2.28 6.804c-1.42 1.914-3.236 3.282-5.537 3.974a1.263 1.263 0 0 1-.764 0 10.435 10.435 0 0 1-5.337-3.697A11.485 11.485 0 0 1 .93 9.05V6.743c0-.962 0-1.925-.014-2.887zm14.313 6.15h.27c0-.081.012-.151.012-.22V5a.23.23 0 0 0-.146-.262c-2.022-.888-4.042-1.782-6.062-2.683-.05-.021-.104-.035-.174-.061V9.854c0 .057 0 .112.014.17-.056 0-.111-.015-.17-.015H2.783c.285 3.115 2.611 7 6.36 8.121v-8.124h6.085z" fill="#FFF" opacity=".9" /></svg>),
  airplane: (
    <svg width="18" height="18">
      <path
        fill="#FFF"
        d="M12.58 6.73a.414.414 0 0 0-.597-.572l-7.44 6.33-3.93-1.52a.954.954 0 0 1-.11-1.734L16.815.096a.804.804 0 0 1 1.181.784l-1.43 14.916a.99.99 0 0 1-1.35.824l-4.783-1.852-3.003 2.813a.776.776 0 0 1-1.304-.572v-2.21l6.453-8.07z"
      />
    </svg>
  ),
  arrow: (
    <svg width="12" height="11">
      <path
        d="M7.58.362a1.263 1.263 0 0 0-1.77 0 1.263 1.263 0 0 0 0 1.77l1.931 1.93h-6.49C.554 4.063 0 4.618 0 5.315s.554 1.251 1.251 1.251H7.76L5.81 8.496a1.263 1.263 0 0 0 0 1.77c.25.25.572.358.876.358.304 0 .644-.125.876-.358l4.076-4.058a1.263 1.263 0 0 0 0-1.77L7.58.362z"
        fill="#9013FE"
      />
    </svg>
  ),
  arrow14: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
    >
      <path
        fill="#9013FE"
        d="M206.843238,14.4222388 C206.280253,13.8592537 205.341666,13.8592537 204.778681,14.4222388 C204.215696,14.985224 204.215696,15.9238106 204.778681,16.4867957 L207.031498,18.7396122 L199.460024,18.7396122 C198.646916,18.7396122 198,19.3865279 198,20.1996359 C198,21.0127439 198.646916,21.6596595 199.460024,21.6596595 L207.05173,21.6596595 L204.778681,23.9124761 C204.215696,24.4754612 204.215696,25.4140478 204.778681,25.9770329 C205.070352,26.2687039 205.445954,26.3941826 205.800364,26.3941826 C206.154774,26.3941826 206.551567,26.2483429 206.822047,25.9770329 L211.577761,21.2425934 C212.140746,20.6796082 212.140746,19.7410216 211.577761,19.1780365 L206.843238,14.4222388 Z"
        transform="rotate(-90 99.5 112.697)"
      />
    </svg>
  ),
  arrowLeft: (
    <svg width="26" height="26">
      <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zM11.157 7.422l-4.735 4.756a1.473 1.473 0 0 0 0 2.065l4.756 4.734c.27.271.667.417 1.022.417.354 0 .73-.125 1.021-.417a1.473 1.473 0 0 0 0-2.065l-2.273-2.252h7.592c.813 0 1.46-.647 1.46-1.46s-.647-1.46-1.46-1.46h-7.571l2.252-2.253a1.473 1.473 0 0 0 0-2.065 1.473 1.473 0 0 0-2.064 0z" />
    </svg>
  ),
  arrowRight: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="11"
      viewBox="0 0 18 11"
    >
      <path
        fill="#9013FE"
        d="M932.916915,15.1726624 L932.214738,15.8465316 C931.9408,16.1085945 931.9408,16.6035008 932.214738,16.8646521 L934.66379,19.2022032 L921.629137,19.2022032 C921.286733,19.2378135 920.998185,19.5601291 921.000009,19.9052919 L921.000009,20.8430473 C921.000009,21.2110246 921.334208,21.5461359 921.702186,21.5461359 L934.663673,21.5461359 C933.847353,22.325008 933.031034,23.104815 932.214621,23.8836871 C931.940683,24.14575 931.940683,24.6406563 932.214621,24.9018075 L932.916798,25.5683836 C933.174302,25.8131018 933.624445,25.8131018 933.881949,25.5683836 C935.288127,24.2279383 937.390146,22.2191403 938.794547,20.8787884 C939.068484,20.6167256 939.068484,20.1218192 938.794547,19.860668 L933.881949,15.1727091 C933.534051,14.9060881 933.235476,14.9818691 932.916798,15.1727091 L932.916915,15.1726624 Z"
        transform="translate(-921 -15)"
      />
    </svg>
  ),
  bbkMiniLogo: (
    <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1">
      <g
        id="Reasons-map"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="v3-01-TAB:-Reasons---default"
          transform="translate(-1130.000000, -828.000000)"
        >
          <g id="Group-13" transform="translate(1101.000000, 694.000000)">
            <g
              id="Dynamic-group-Copy"
              transform="translate(29.000000, 131.000000)"
            >
              <g id="logomark" transform="translate(0.000000, 3.000000)">
                <polygon
                  id="Fill-110-Copy-11"
                  fill="#FF75B3"
                  points="16.7930029 18.3603635 11.1953353 18.3603635 13.9941691 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-10"
                  fill="#FF7575"
                  points="19.5918367 13.7702624 13.9941691 13.7702624 16.7930029 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-14"
                  fill="#C76ECC"
                  points="11.1953353 18.3603635 5.59766764 18.3603635 8.39650146 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-13"
                  fill="#EB73D5"
                  points="13.9941691 13.7702624 8.39650146 13.7702624 11.1953353 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-16"
                  fill="#745185"
                  points="5.59766764 18.3603635 0 18.3603635 2.79883382 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-15"
                  fill="#9260AB"
                  points="8.39650146 13.7702624 2.79883382 13.7702624 5.59766764 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-17"
                  fill="#745185"
                  points="8.39650146 13.7702761 2.79883382 13.7702761 5.59766764 9.18017493"
                />
                <polygon
                  id="Fill-110-Copy-12"
                  fill="#FF9C75"
                  points="19.5918367 13.7702761 13.9941691 13.7702761 16.7930029 9.18017493"
                />
                <polygon
                  id="Fill-110-Copy-9"
                  fill="#FFB575"
                  points="16.7930029 9.18017493 11.1953353 9.18017493 13.9941691 13.7702487"
                />
                <polygon
                  id="Fill-110"
                  fill="#5E3799"
                  points="5.59766764 9.18018859 0 9.18018859 2.79883382 4.59008746"
                />
                <polygon
                  id="Fill-110-Copy"
                  fill="#425AB8"
                  points="8.39650146 4.59008746 2.79883382 4.59008746 5.59766764 9.18016126"
                />
                <polygon
                  id="Fill-110-Copy-8"
                  fill="#FFD175"
                  points="16.7930029 9.18018859 11.1953353 9.18018859 13.9941691 4.59008746"
                />
                <polygon
                  id="Fill-110-Copy-7"
                  fill="#FFF175"
                  points="19.5918367 4.59008746 13.9941691 4.59008746 16.7930029 9.18016126"
                />
                <polygon
                  id="Fill-110-Copy-2"
                  fill="#0E96B8"
                  points="8.39650146 4.59010113 2.79883382 4.59010113 5.59766764 0"
                />
                <polygon
                  id="Fill-110-Copy-6"
                  fill="#A5ED4E"
                  points="19.5918367 4.59010113 13.9941691 4.59010113 16.7930029 0"
                />
                <polygon
                  id="Fill-110-Copy-3"
                  fill="#0CB07C"
                  points="11.1953353 0 5.59766764 0 8.39650146 4.5900738"
                />
                <polygon
                  id="Fill-110-Copy-5"
                  fill="#27BA51"
                  points="13.9941691 4.59010113 8.39650146 4.59010113 11.1953353 0"
                />
                <polygon
                  id="Fill-110-Copy-4"
                  fill="#6FD640"
                  points="16.7930029 0 11.1953353 0 13.9941691 4.5900738"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  bbkMiniLogoTrans: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
    >
      <g fill="#FFF" fillRule="evenodd">
        <polygon
          points="18.472 20.196 12.315 20.196 15.394 15.147"
          opacity=".6"
        />
        <polygon
          points="21.551 15.147 15.394 15.147 18.472 20.196"
          opacity=".8"
        />
        <polygon
          points="12.315 20.196 6.157 20.196 9.236 15.147"
          opacity=".4"
        />
        <polygon
          points="15.394 15.147 9.236 15.147 12.315 20.196"
          opacity=".5"
        />
        <polygon points="6.157 20.196 0 20.196 3.079 15.147" opacity=".4" />
        <polygon points="9.236 15.147 3.079 15.147 6.157 20.196" opacity=".3" />
        <polygon points="9.236 15.147 3.079 15.147 6.157 10.098" opacity=".2" />
        <polygon
          points="21.551 15.147 15.394 15.147 18.472 10.098"
          opacity=".7"
        />
        <polygon
          points="18.472 10.098 12.315 10.098 15.394 15.147"
          opacity=".8"
        />
        <polygon points="6.157 10.098 0 10.098 3.079 5.049" opacity=".2" />
        <polygon points="9.236 5.049 3.079 5.049 6.157 10.098" opacity=".4" />
        <polygon
          points="18.472 10.098 12.315 10.098 15.394 5.049"
          opacity=".7"
        />
        <polygon
          points="21.551 5.049 15.394 5.049 18.472 10.098"
          opacity=".8"
        />
        <polygon points="9.236 5.049 3.079 5.049 6.157 0" opacity=".3" />
        <polygon points="21.551 5.049 15.394 5.049 18.472 0" opacity=".8" />
        <polygon points="12.315 0 6.157 0 9.236 5.049" opacity=".4" />
        <polygon points="15.394 5.049 9.236 5.049 12.315 0" opacity=".3" />
        <polygon points="18.472 0 12.315 0 15.394 5.049" opacity=".6" />
      </g>
    </svg>
  ),
  brightback: (
    <svg width="177" height="30" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M168.822 18.212l3.359 5.618h4.218l-5.07-8.501 4.984-5.615h-4.43l-5.044 5.688h-.049V2.541h-3.786v21.29h3.786v-3.376l1.987-2.243h.045zm-13.737 5.858c1.356 0 2.573-.236 3.648-.708 1.079-.468 1.942-1.08 2.593-1.836l-2.601-2.284a4.193 4.193 0 0 1-1.393 1.021c-.553.27-1.185.408-1.88.408-1.12 0-2.028-.363-2.733-1.091-.7-.721-1.05-1.666-1.05-2.822 0-.566.09-1.087.269-1.567.179-.48.431-.892.757-1.23.322-.334.72-.603 1.189-.794.472-.195.985-.29 1.539-.29 1.327 0 2.422.502 3.29 1.511l2.552-2.202c-.696-.88-1.58-1.547-2.65-2.011a8.294 8.294 0 0 0-3.347-.7c-1.441 0-2.724.305-3.856.92a6.525 6.525 0 0 0-2.634 2.577c-.63 1.115-.953 2.381-.953 3.815 0 1.42.318 2.687.94 3.794a6.552 6.552 0 0 0 2.594 2.577c1.1.607 2.341.912 3.726.912zm-16.445-3.387c-1.058 0-1.934-.358-2.601-1.075-.676-.713-1.014-1.645-1.014-2.78 0-1.186.35-2.138 1.042-2.867.688-.72 1.551-1.083 2.59-1.083 1.026 0 1.872.374 2.548 1.128.672.749 1.01 1.69 1.01 2.821 0 1.136-.346 2.068-1.03 2.781-.688.717-1.54 1.075-2.545 1.075zm3.416-10.969v1.592h-.053c-1.054-1.221-2.443-1.832-4.169-1.832-.928 0-1.808.183-2.63.554a6.432 6.432 0 0 0-2.121 1.506c-.587.64-1.047 1.417-1.385 2.333a8.38 8.38 0 0 0-.513 2.948c0 1.075.176 2.06.513 2.972.338.904.803 1.67 1.401 2.3a6.284 6.284 0 0 0 2.15 1.458c.834.35 1.73.525 2.703.525 1.804 0 3.213-.651 4.222-1.946h.061v1.706h3.604V9.714h-3.783zm-19.644 10.969c-1.055 0-1.938-.358-2.643-1.075-.716-.713-1.067-1.645-1.067-2.78 0-1.137.347-2.081 1.039-2.83.7-.75 1.588-1.12 2.67-1.12 1.035 0 1.898.362 2.582 1.083.688.729 1.034 1.681 1.034 2.866 0 1.136-.338 2.068-1.01 2.781-.671.717-1.543 1.075-2.605 1.075zm.806-11.209c-1.78 0-3.196.61-4.263 1.832h-.07V2.541h-3.79v21.29h3.616v-1.707h.073c1.026 1.295 2.467 1.946 4.32 1.946.969 0 1.868-.175 2.703-.525a6.307 6.307 0 0 0 2.146-1.458c.594-.63 1.062-1.396 1.4-2.3.342-.912.51-1.897.51-2.972 0-1.059-.168-2.04-.51-2.948-.338-.916-.798-1.693-1.384-2.333a6.39 6.39 0 0 0-2.121-1.506 6.35 6.35 0 0 0-2.63-.554zM109.656 24.07c.863 0 1.571-.077 2.117-.228a7.232 7.232 0 0 0 1.62-.663l-.969-3.021c-.643.333-1.233.496-1.775.496-.448 0-.765-.146-.96-.44-.192-.292-.286-.744-.286-1.367v-5.998h3.84V9.714h-3.84V4.686l-3.786.411v4.617h-1.665v3.135h1.665v6.519c0 1.547.358 2.711 1.083 3.51.72.793 1.706 1.192 2.956 1.192zM97.393 9.474c-.912 0-1.763.167-2.545.493-.786.33-1.47.814-2.044 1.457h-.053V2.541h-3.786v21.29h3.786v-7.154c0-1.246.29-2.19.871-2.834.587-.648 1.393-.965 2.431-.965.937 0 1.633.256 2.08.774.449.517.668 1.404.668 2.65v7.54h3.803v-8.497c0-1.05-.13-1.962-.387-2.732-.248-.765-.614-1.372-1.083-1.828a4.296 4.296 0 0 0-1.632-.993c-.611-.216-1.315-.318-2.11-.318zM79.035 20.145c-.408 0-.79-.057-1.153-.158a3.624 3.624 0 0 1-.985-.477 3.145 3.145 0 0 1-.773-.749 3.233 3.233 0 0 1-.501-1.005 4.33 4.33 0 0 1-.18-1.238c0-1.063.338-1.93 1.002-2.598.672-.668 1.535-1.005 2.59-1.005 1.013 0 1.864.333 2.544.989.68.66 1.026 1.523 1.026 2.59 0 1.058-.338 1.933-1.005 2.617-.668.692-1.527 1.034-2.565 1.034zm3.4-10.43v1.453h-.07a5.484 5.484 0 0 0-1.914-1.262 6.217 6.217 0 0 0-2.308-.432c-1.242 0-2.362.306-3.359.92-.998.607-1.775 1.462-2.337 2.553-.558 1.091-.839 2.32-.839 3.685 0 1.343.29 2.548.867 3.603a6.226 6.226 0 0 0 2.403 2.467c1.017.582 2.17.872 3.464.872 1.694 0 3.062-.55 4.109-1.653h.065v1.429c0 .903-.346 1.649-1.043 2.243-.696.594-1.677.892-2.947.892-.843 0-1.62-.118-2.346-.342-.724-.22-1.473-.55-2.243-.973l-.875 3.188c1.657.956 3.583 1.424 5.785 1.424 1.063 0 2.012-.118 2.846-.366.835-.244 1.531-.586 2.097-1.03a5.553 5.553 0 0 0 1.396-1.612 7.08 7.08 0 0 0 .79-2.08c.16-.758.24-1.58.24-2.488V9.714h-3.782zM65.586 23.83h3.782V9.714h-3.782V23.83zm1.889-16.106c.639 0 1.189-.229 1.653-.676.46-.452.692-.998.692-1.641 0-.627-.232-1.169-.692-1.62a2.289 2.289 0 0 0-1.653-.68c-.652 0-1.201.227-1.657.68-.46.451-.684.993-.684 1.62 0 .427.097.814.31 1.164.207.359.488.635.854.843.362.208.753.31 1.177.31zm-3.864 1.75c-.843 0-1.625.2-2.357.599-.733.403-1.368.973-1.91 1.718h-.036V9.714h-3.787V23.83h3.787v-6.55c0-1.084.317-1.967.948-2.651.635-.692 1.519-1.034 2.65-1.034.29 0 .628.016 1.002.044V9.486c-.057-.012-.159-.012-.297-.012zM45.466 20.26h-3.278v-5.28h3.314c1.177 0 2.08.236 2.687.712.62.477.929 1.128.929 1.959 0 .57-.155 1.054-.464 1.44-.31.396-.737.689-1.275.88-.545.192-1.18.29-1.913.29zM42.188 6.89h2.642c.77 0 1.41.102 1.918.301.51.204.876.48 1.104.83.223.347.333.77.333 1.255 0 .545-.146 1.005-.443 1.376a2.5 2.5 0 0 1-1.12.806c-.452.163-.96.244-1.527.244h-2.907V6.89zm7.044 6.058v-.06a4.677 4.677 0 0 0 1.779-1.161c.472-.505.806-1.039 1.002-1.609.199-.57.297-1.176.297-1.815 0-1.629-.57-2.867-1.718-3.726-1.145-.859-2.806-1.286-4.988-1.286h-7.41v20.54h8.497c1.103 0 2.08-.138 2.927-.423.851-.281 1.552-.68 2.093-1.185a5.005 5.005 0 0 0 1.226-1.796c.277-.688.415-1.445.415-2.271 0-1.344-.358-2.468-1.07-3.364-.717-.903-1.731-1.514-3.05-1.844z"
          fill="#FFF"
        />
        <path
          fill="#27BA51"
          d="M14.8 0l3.697 6.408h-7.398l1.848-3.204L14.8 0"
        />
        <path
          fill="#27BA51"
          d="M14.8 0l3.697 6.408h-7.398l1.848-3.204L14.8 0"
        />
        <path fill="#6FD640" d="M18.497 6.408L22.193 0H14.8l3.697 6.408" />
        <path fill="#6FD640" d="M18.497 6.408L22.193 0H14.8l3.697 6.408" />
        <path
          fill="#A5ED4E"
          d="M22.193 0l1.853 3.204 1.848 3.204h-7.397L22.193 0"
        />
        <path
          fill="#A5ED4E"
          d="M22.193 0l1.853 3.204 1.848 3.204h-7.397L22.193 0"
        />
        <path
          fill="#FFF175"
          d="M22.193 12.813l1.853-3.2 1.848-3.205h-7.397l1.848 3.205 1.848 3.2"
        />
        <path
          fill="#FFF175"
          d="M22.193 12.813l1.853-3.2 1.848-3.205h-7.397l1.848 3.205 1.848 3.2"
        />
        <path
          fill="#FFD175"
          d="M18.497 6.408l1.848 3.205 1.848 3.2H14.8l1.848-3.2 1.849-3.205"
        />
        <path
          fill="#FFD175"
          d="M18.497 6.408l1.848 3.205 1.848 3.2H14.8l1.848-3.2 1.849-3.205"
        />
        <path
          fill="#5E3799"
          d="M3.7 6.408l1.85 3.205 1.848 3.2H0l1.853-3.2L3.7 6.408"
        />
        <path
          fill="#5E3799"
          d="M3.7 6.408l1.85 3.205 1.848 3.2H0l1.853-3.2L3.7 6.408"
        />
        <path
          fill="#FF9C75"
          d="M22.193 12.813l1.853 3.204 1.848 3.204h-7.397l3.696-6.408"
        />
        <path
          fill="#FF9C75"
          d="M22.193 12.813l1.853 3.204 1.848 3.204h-7.397l3.696-6.408"
        />
        <path fill="#FFB575" d="M18.497 19.221l3.696-6.408H14.8l3.697 6.408" />
        <path fill="#FFB575" d="M18.497 19.221l3.696-6.408H14.8l3.697 6.408" />
        <path
          fill="#FF7575"
          d="M22.193 25.626l1.853-3.2 1.848-3.205h-7.397l1.848 3.204 1.848 3.2"
        />
        <path
          fill="#FF7575"
          d="M22.193 25.626l1.853-3.2 1.848-3.205h-7.397l1.848 3.204 1.848 3.2"
        />
        <path
          fill="#FF75B3"
          d="M18.497 19.221l1.848 3.204 1.848 3.2H14.8l1.848-3.2 1.849-3.204"
        />
        <path
          fill="#FF75B3"
          d="M18.497 19.221l1.848 3.204 1.848 3.2H14.8l1.848-3.2 1.849-3.204"
        />
        <path
          fill="#EB73D5"
          d="M14.8 25.626l1.848-3.2 1.849-3.205h-7.398l1.848 3.204 1.853 3.2"
        />
        <path
          fill="#EB73D5"
          d="M14.8 25.626l1.848-3.2 1.849-3.205h-7.398l1.848 3.204 1.853 3.2"
        />
        <path
          fill="#C76ECC"
          d="M11.099 19.221l1.848 3.204 1.849 3.2H7.398l3.7-6.404"
        />
        <path
          fill="#C76ECC"
          d="M11.099 19.221l1.848 3.204 1.849 3.2H7.398l3.7-6.404"
        />
        <path
          fill="#0CB07C"
          d="M11.099 6.408l1.848-3.204L14.8 0H7.398l1.848 3.204L11.1 6.408"
        />
        <path
          fill="#0CB07C"
          d="M11.099 6.408l1.848-3.204L14.8 0H7.398l1.848 3.204L11.1 6.408"
        />
        <path fill="#0E96B8" d="M7.398 0l1.848 3.204L11.1 6.408H3.7L7.398 0" />
        <path fill="#0E96B8" d="M7.398 0l1.848 3.204L11.1 6.408H3.7L7.398 0" />
        <path
          fill="#425AB8"
          d="M7.398 12.813l3.7-6.405H3.702l1.848 3.205 1.849 3.2"
        />
        <path
          fill="#425AB8"
          d="M7.398 12.813l3.7-6.405H3.702l1.848 3.205 1.849 3.2"
        />
        <path
          fill="#745185"
          d="M3.7 19.221l1.85 3.204 1.848 3.2H0l1.853-3.2L3.7 19.221"
        />
        <path
          fill="#745185"
          d="M3.7 19.221l1.85 3.204 1.848 3.2H0l1.853-3.2L3.7 19.221M7.398 12.813l1.848 3.204 1.853 3.204H3.7l3.697-6.408"
        />
        <path
          fill="#745185"
          d="M7.398 12.813l1.848 3.204 1.853 3.204H3.7l3.697-6.408"
        />
        <path
          fill="#9260AB"
          d="M7.398 25.626l3.7-6.405H3.702l1.848 3.204 1.849 3.2"
        />
        <path
          fill="#9260AB"
          d="M7.398 25.626l3.7-6.405H3.702l1.848 3.204 1.849 3.2"
        />
      </g>
    </svg>
  ),
  brightbackIcon: bbkIcon,
  brightbackjs: bbkIcon,
  brightbackMiniLogo: (
    <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1">
      <g
        id="Reasons-map"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="v3-01-TAB:-Reasons---default"
          transform="translate(-1130.000000, -828.000000)"
        >
          <g id="Group-13" transform="translate(1101.000000, 694.000000)">
            <g
              id="Dynamic-group-Copy"
              transform="translate(29.000000, 131.000000)"
            >
              <g id="logomark" transform="translate(0.000000, 3.000000)">
                <polygon
                  id="Fill-110-Copy-11"
                  fill="#FF75B3"
                  points="16.7930029 18.3603635 11.1953353 18.3603635 13.9941691 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-10"
                  fill="#FF7575"
                  points="19.5918367 13.7702624 13.9941691 13.7702624 16.7930029 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-14"
                  fill="#C76ECC"
                  points="11.1953353 18.3603635 5.59766764 18.3603635 8.39650146 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-13"
                  fill="#EB73D5"
                  points="13.9941691 13.7702624 8.39650146 13.7702624 11.1953353 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-16"
                  fill="#745185"
                  points="5.59766764 18.3603635 0 18.3603635 2.79883382 13.7702624"
                />
                <polygon
                  id="Fill-110-Copy-15"
                  fill="#9260AB"
                  points="8.39650146 13.7702624 2.79883382 13.7702624 5.59766764 18.3603362"
                />
                <polygon
                  id="Fill-110-Copy-17"
                  fill="#745185"
                  points="8.39650146 13.7702761 2.79883382 13.7702761 5.59766764 9.18017493"
                />
                <polygon
                  id="Fill-110-Copy-12"
                  fill="#FF9C75"
                  points="19.5918367 13.7702761 13.9941691 13.7702761 16.7930029 9.18017493"
                />
                <polygon
                  id="Fill-110-Copy-9"
                  fill="#FFB575"
                  points="16.7930029 9.18017493 11.1953353 9.18017493 13.9941691 13.7702487"
                />
                <polygon
                  id="Fill-110"
                  fill="#5E3799"
                  points="5.59766764 9.18018859 0 9.18018859 2.79883382 4.59008746"
                />
                <polygon
                  id="Fill-110-Copy"
                  fill="#425AB8"
                  points="8.39650146 4.59008746 2.79883382 4.59008746 5.59766764 9.18016126"
                />
                <polygon
                  id="Fill-110-Copy-8"
                  fill="#FFD175"
                  points="16.7930029 9.18018859 11.1953353 9.18018859 13.9941691 4.59008746"
                />
                <polygon
                  id="Fill-110-Copy-7"
                  fill="#FFF175"
                  points="19.5918367 4.59008746 13.9941691 4.59008746 16.7930029 9.18016126"
                />
                <polygon
                  id="Fill-110-Copy-2"
                  fill="#0E96B8"
                  points="8.39650146 4.59010113 2.79883382 4.59010113 5.59766764 0"
                />
                <polygon
                  id="Fill-110-Copy-6"
                  fill="#A5ED4E"
                  points="19.5918367 4.59010113 13.9941691 4.59010113 16.7930029 0"
                />
                <polygon
                  id="Fill-110-Copy-3"
                  fill="#0CB07C"
                  points="11.1953353 0 5.59766764 0 8.39650146 4.5900738"
                />
                <polygon
                  id="Fill-110-Copy-5"
                  fill="#27BA51"
                  points="13.9941691 4.59010113 8.39650146 4.59010113 11.1953353 0"
                />
                <polygon
                  id="Fill-110-Copy-4"
                  fill="#6FD640"
                  points="16.7930029 0 11.1953353 0 13.9941691 4.5900738"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  brightbackPurple: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="174"
      height="30"
      viewBox="0 0 174 30"
    >
      <g fill="none" fillRule="evenodd">
        <polygon
          fill="#FF75B3"
          points="24.466 26.776 16.311 26.776 20.389 20.082"
        />
        <polygon
          fill="#FF7575"
          points="28.544 20.082 20.389 20.082 24.466 26.775"
        />
        <polygon
          fill="#C76ECC"
          points="16.311 26.776 8.155 26.776 12.233 20.082"
        />
        <polygon
          fill="#EB73D5"
          points="20.389 20.082 12.233 20.082 16.311 26.775"
        />
        <polygon fill="#745185" points="8.155 26.776 0 26.776 4.078 20.082" />
        <polygon
          fill="#9260AB"
          points="12.233 20.082 4.078 20.082 8.155 26.775"
        />
        <polygon
          fill="#745185"
          points="12.233 20.082 4.078 20.082 8.155 13.388"
        />
        <polygon
          fill="#FF9C75"
          points="28.544 20.082 20.389 20.082 24.466 13.388"
        />
        <polygon
          fill="#FFB575"
          points="24.466 13.388 16.311 13.388 20.389 20.082"
        />
        <polygon fill="#5E3799" points="8.155 13.388 0 13.388 4.078 6.694" />
        <polygon
          fill="#425AB8"
          points="12.233 6.694 4.078 6.694 8.155 13.388"
        />
        <polygon
          fill="#FFD175"
          points="24.466 13.388 16.311 13.388 20.389 6.694"
        />
        <polygon
          fill="#FFF175"
          points="28.544 6.694 20.389 6.694 24.466 13.388"
        />
        <polygon fill="#0E96B8" points="12.233 6.694 4.078 6.694 8.155 0" />
        <polygon fill="#A5ED4E" points="28.544 6.694 20.389 6.694 24.466 0" />
        <polygon fill="#0CB07C" points="16.311 0 8.155 0 12.233 6.694" />
        <polygon fill="#27BA51" points="20.389 6.694 12.233 6.694 16.311 0" />
        <polygon fill="#6FD640" points="24.466 0 16.311 0 20.389 6.694" />
        <path
          fill="#230067"
          d="M45.9274368,12.8 C48.5534928,13.4571429 50.0377854,15.2857143 50.0377854,17.9714286 C50.0377854,21.2 47.8684347,23.5714286 43.4441012,23.5714286 L35.0521394,23.5714286 L35.0521394,3.28571429 L42.3594258,3.28571429 C46.669583,3.28571429 48.9816541,5 48.9816541,8.22857143 C48.9816541,10.0571429 48.1538756,11.9142857 45.9274368,12.7714286 L45.9274368,12.8 Z M38.9912235,6.82857143 L38.9912235,11.6 L41.8741763,11.6 C43.4726452,11.6 44.9283937,10.8571429 44.9283937,9.2 C44.9283937,7.77142857 43.9578947,6.82857143 41.6172796,6.82857143 L38.9912235,6.82857143 Z M42.2452495,20.0285714 C44.386056,20.0285714 45.8418045,19.2 45.8418045,17.4571429 C45.8418045,15.8571429 44.6714969,14.8285714 42.2737936,14.8285714 L38.9912235,14.8285714 L38.9912235,20.0285714 L42.2452495,20.0285714 Z M60.370745,9.4 C60.4849214,9.4 60.5990977,9.4 60.6561859,9.42857143 L60.6561859,13.4857143 C60.2851128,13.4571429 59.8854956,13.4571429 59.6856869,13.4571429 C57.3736159,13.4571429 56.117676,15.0285714 56.117676,17.0857143 L56.117676,23.5714286 L52.3784005,23.5714286 L52.3784005,9.62857143 L56.117676,9.62857143 L56.117676,11.6857143 L56.1462201,11.6857143 C57.2023513,10.2 58.715188,9.4 60.370745,9.4 Z M64.4240055,7.65714286 C63.1680656,7.65714286 62.1119344,6.62857143 62.1119344,5.37142857 C62.1119344,4.11428571 63.1680656,3.08571429 64.4240055,3.08571429 C65.7084894,3.08571429 66.7646206,4.11428571 66.7646206,5.37142857 C66.7646206,6.62857143 65.7084894,7.65714286 64.4240055,7.65714286 Z M62.5400957,23.5714286 L62.5400957,9.62857143 L66.2793712,9.62857143 L66.2793712,23.5714286 L62.5400957,23.5714286 Z M79.4096514,9.62857143 L83.1203828,9.62857143 L83.1203828,21.9714286 C83.1203828,26.3142857 81.2079289,29.4571429 75.8701846,29.4571429 C73.6722898,29.4571429 71.78838,28.9714286 70.132823,28.0571429 L71.0176897,24.8857143 C72.3878059,25.6571429 73.7579221,26.2 75.5276555,26.2 C78.1537116,26.2 79.4952837,24.8 79.4952837,23.0857143 L79.4952837,21.6857143 L79.4096514,21.6857143 C78.4391524,22.7428571 77.0404921,23.3142857 75.356391,23.3142857 C71.5029392,23.3142857 68.7056186,20.5142857 68.7056186,16.4571429 C68.7056186,12.3428571 71.4173069,9.4 75.1565824,9.4 C76.7265072,9.4 78.2107997,9.94285714 79.3240191,11.0571429 L79.4096514,11.0571429 L79.4096514,9.62857143 Z M76.0414491,19.9428571 C78.0966234,19.9428571 79.5523718,18.4285714 79.5523718,16.3142857 C79.5523718,14.1714286 78.0109911,12.8 76.0414491,12.8 C73.9577307,12.8 72.5019822,14.2285714 72.5019822,16.3428571 C72.5019822,18.5428571 74.043363,19.9428571 76.0414491,19.9428571 Z M94.3952973,9.4 C97.3924265,9.4 99.5332331,10.9428571 99.5332331,15.2 L99.5332331,23.5714286 L95.7939576,23.5714286 L95.7939576,16.1428571 C95.7939576,13.5714286 94.8520027,12.7428571 93.0822693,12.7428571 C91.0841832,12.7428571 89.7996992,14 89.7996992,16.4857143 L89.7996992,23.5714286 L86.0604238,23.5714286 L86.0604238,2.54285714 L89.7996992,2.54285714 L89.7996992,11.3142857 L89.8567874,11.3142857 C90.9985509,10.0285714 92.6255639,9.4 94.3952973,9.4 Z M106.726343,23.8 C104.32864,23.8 102.758715,22.3142857 102.758715,19.1714286 L102.758715,12.7142857 L101.103158,12.7142857 L101.103158,9.62857143 L102.758715,9.62857143 L102.758715,5.05714286 L106.469446,4.65714286 L106.469446,9.62857143 L110.26581,9.62857143 L110.26581,12.7142857 L106.469446,12.7142857 L106.469446,18.6571429 C106.469446,19.8571429 106.840519,20.4285714 107.696842,20.4285714 C108.153548,20.4285714 108.838606,20.2571429 109.466576,19.9428571 L110.437075,22.9428571 C109.523664,23.4285714 108.610253,23.8 106.726343,23.8 Z M120.341873,9.4 C124.081148,9.4 126.907013,12.4 126.907013,16.6285714 C126.907013,20.9428571 124.109692,23.8 120.227697,23.8 C118.372331,23.8 116.945126,23.1142857 115.974627,21.8857143 L115.888995,21.8857143 L115.888995,23.5714286 L112.320984,23.5714286 L112.320984,2.54285714 L116.06026,2.54285714 L116.06026,11.2 L116.145892,11.2 C117.173479,10 118.629228,9.4 120.341873,9.4 Z M119.542638,20.4571429 C121.654901,20.4571429 123.110649,18.9142857 123.110649,16.6571429 C123.110649,14.2571429 121.540725,12.7428571 119.542638,12.7428571 C117.401832,12.7428571 115.888995,14.4285714 115.888995,16.6571429 C115.888995,18.9428571 117.516008,20.4571429 119.542638,20.4571429 Z M139.180971,9.62857143 L142.891702,9.62857143 L142.891702,23.5714286 L139.352235,23.5714286 L139.352235,21.8857143 L139.266603,21.8857143 C138.324648,23.1142857 136.897444,23.8 135.099166,23.8 C131.245714,23.8 128.448394,20.9428571 128.448394,16.6285714 C128.448394,12.4 131.274258,9.4 135.013534,9.4 C136.669091,9.4 138.096295,10 139.095338,11.2 L139.180971,11.2 L139.180971,9.62857143 Z M135.784224,20.4571429 C137.725222,20.4571429 139.323691,18.9428571 139.323691,16.6571429 C139.323691,14.4285714 137.839398,12.7428571 135.812768,12.7428571 C133.814682,12.7428571 132.216213,14.2571429 132.216213,16.6571429 C132.216213,18.9142857 133.700506,20.4571429 135.784224,20.4571429 Z M152.254163,23.8 C148.11527,23.8 145.089597,20.8857143 145.089597,16.6 C145.089597,12.3142857 148.11527,9.4 152.425427,9.4 C154.651866,9.4 156.935393,10.2857143 158.334053,12.0571429 L155.822174,14.2285714 C155.080027,13.3714286 153.995352,12.7428571 152.568148,12.7428571 C150.341709,12.7428571 148.857416,14.3142857 148.857416,16.5714286 C148.857416,18.8571429 150.398797,20.4571429 152.596692,20.4571429 C154.080984,20.4571429 155.194204,19.7714286 155.850718,19.0285714 L158.391141,21.2857143 C157.19229,22.6857143 155.051483,23.8 152.254163,23.8 Z M166.012413,18.0285714 L165.955325,18.0285714 L164.014327,20.2285714 L164.014327,23.5714286 L160.275051,23.5714286 L160.275051,2.54285714 L164.014327,2.54285714 L164.014327,15.2571429 L164.042871,15.2571429 L169.038086,9.62857143 L173.405332,9.62857143 L168.495748,15.1714286 L173.490964,23.5714286 L169.323527,23.5714286 L166.012413,18.0285714 Z"
        />
      </g>
    </svg>
  ),
  chat: (
    <svg width="20" height="18">
      <path
        d="M10 15.511c.933 0 1.845-.088 2.734-.289l4.421 2.356-.377-4.111c.155-.111.31-.222.467-.356C19.023 11.667 20 9.755 20 7.755 20 3.466 15.511 0 10 0S0 3.467 0 7.755c0 4.267 4.489 7.756 10 7.756zm3.155-7.578c0-.667.533-1.2 1.2-1.2.667 0 1.2.533 1.2 1.2 0 .667-.533 1.2-1.2 1.2-.666-.022-1.2-.555-1.2-1.2zm-1.955 0c0 .667-.533 1.2-1.2 1.2-.667 0-1.2-.533-1.2-1.2 0-.667.533-1.2 1.2-1.2.667 0 1.2.533 1.2 1.2zm-5.556-1.2c.667 0 1.2.533 1.2 1.2 0 .667-.533 1.2-1.2 1.2-.666 0-1.2-.533-1.2-1.2.023-.667.556-1.2 1.2-1.2z"
        fill="#000"
        opacity=".3"
      />
    </svg>
  ),
  check: (
    <svg width="18" height="14">
      <path
        d="M0 7.558l1.94-2.492L7.123 9.34 15.641 0 18 2.114 7.454 13.764z"
        fill="#25CDA8"
      />
    </svg>
  ),
  checkmark: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 11"
      width="14"
      height="11"
    >
      <path
        fill="#FFF"
        d="M9.06764833,13.1413828 L5.89389204,9.98890436 C5.78562148,9.8806338 5.60955304,9.88282178 5.50345786,9.98890436 L4.08120292,11.4199784 C3.97293236,11.528249 3.97293236,11.7043174 4.08120292,11.8125964 C5.68179967,13.4026942 7.2805766,14.992932 8.88117335,16.58079 C8.98944391,16.6890606 9.16551235,16.6890606 9.27379131,16.58079 L17.9207094,7.89397603 C18.026792,7.78570547 18.026792,7.60963703 17.9185221,7.50135807 L16.4874481,6.08120292 C16.3791775,5.97293236 16.2031091,5.97293236 16.0948301,6.08120292 L9.06824677,13.1422227 L9.06764833,13.1413828 Z"
        transform="translate(-4 -6)"
      />
    </svg>
  ),
  chevronDown: (
    <svg width="10" height="5">
      <path d="M.273.192a1.004 1.004 0 0 1 1.182 0L5 3.355 8.546.192a1.004 1.004 0 0 1 1.181 0 .619.619 0 0 1 0 1.026l-4.273 3.59a1.004 1.004 0 0 1-1.181 0l-4-3.59C.09 1.048 0 .876 0 .705 0 .45.091.278.273.193" />
    </svg>
  ),
  chevronDownMed: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="6"
      viewBox="0 0 12 6"
    >
      <path
        fill="#9013FE"
        d="M993.327801,489.230703 C993.764218,488.923099 994.309862,488.923099 994.745762,489.230703 L999.000245,493.025498 L1003.25473,489.230703 C1003.69114,488.923099 1004.23679,488.923099 1004.67269,489.230703 C1005.1091,489.538308 1005.1091,490.153945 1004.67269,490.461527 L999.5453,494.769297 C999.108884,495.076901 998.56324,495.076901 998.127339,494.769297 L993.327201,490.461527 C993.109227,490.256608 993,490.051249 993,489.846329 C993,489.538725 993.109222,489.333366 993.327201,489.231132"
        transform="translate(-993 -489)"
      />
    </svg>
  ),
  close: (
    <svg width="16" height="16" viewBox="0 0 16 16">
      <path d="M7.557 9.514l-5.349 5.348c-.41.411-1.182.306-1.722-.234-.541-.541-.646-1.312-.235-1.723l5.348-5.348L.251 2.208C-.16 1.798-.055 1.026.486.486 1.026-.055 1.797-.16 2.208.25l5.349 5.348L12.905.251c.41-.411 1.182-.306 1.723.235.54.54.645 1.311.234 1.722L9.514 7.557l5.348 5.348c.411.41.306 1.182-.234 1.723-.541.54-1.312.645-1.723.234L7.557 9.514z" />
    </svg>
  ),
  closeProper: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        fillRule="evenodd"
        d="M18.4484158,6.18737276 C18.8164093,5.82577537 19.0007944,5.38593235 18.9999974,4.86947851 C19.0007956,4.35302466 18.8164012,3.90999378 18.4484158,3.54120327 C18.0868184,3.17960588 17.6469754,2.99920567 17.1305215,3.00000264 C16.6140677,2.99920445 16.1710368,3.17960793 15.8022463,3.54120327 L11.0000205,8.35385097 L6.18737276,3.54120327 C5.82577537,3.17960588 5.38593235,2.99920567 4.86947851,3.00000264 C4.35302466,2.99920445 3.90999378,3.17960793 3.54120327,3.54120327 C3.17960588,3.90999378 2.99920567,4.35302466 3.00000264,4.86947851 C2.99920445,5.38593235 3.17960793,5.82577537 3.54120327,6.18737276 L8.35385097,11.0000205 L3.54120327,15.8022463 C3.17960588,16.1710368 2.99920567,16.6140677 3.00000264,17.1305215 C2.99920445,17.6469754 3.17960793,18.0868184 3.54120327,18.4484158 C3.90999378,18.8164093 4.35302466,19.0007944 4.86947851,18.9999974 C5.38593235,19.0007956 5.82577537,18.8164012 6.18737276,18.4484158 L11.0000205,13.64619 L15.8022463,18.4484158 C16.1710368,18.8164093 16.6140677,19.0007944 17.1305215,18.9999974 C17.6469754,19.0007956 18.0868184,18.8164012 18.4484158,18.4484158 C18.8164093,18.0868184 19.0007944,17.6469754 18.9999974,17.1305215 C19.0007956,16.6140677 18.8164012,16.1710368 18.4484158,15.8022463 L13.64619,11.0000205 L18.4484158,6.18737276 Z"
      />
    </svg>
  ),
  close14: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path
        fill="#9013FE"
        d="M315,21.8133821 L310.04574,26.7676421 C309.665014,27.1483678 308.950535,27.0510518 308.449742,26.5502582 C307.948948,26.0494646 307.851632,25.3349857 308.232358,24.95426 L313.186618,20 L308.232358,15.04574 C307.851632,14.6650143 307.948948,13.9505354 308.449742,13.4497418 C308.950535,12.9489482 309.665014,12.8516322 310.04574,13.2323579 L315,18.1866179 L319.95426,13.2323579 C320.334986,12.8516322 321.049465,12.9489482 321.550258,13.4497418 C322.051052,13.9505354 322.148368,14.6650143 321.767642,15.04574 L316.813382,20 L321.767642,24.95426 C322.148368,25.3349857 322.051052,26.0494646 321.550258,26.5502582 C321.049465,27.0510518 320.334986,27.1483678 319.95426,26.7676421 L315,21.8133821 Z"
        transform="translate(-308 -13)"
      />
    </svg>
  ),
  closeModal: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path
        d="M563.790488,48.3397954 L558,54.1367632 L552.209512,48.3397954 C551.760654,47.8904355 551.064566,47.8904355 550.615708,48.3397954 L549.336643,49.6202915 C548.887786,50.0696514 548.887786,50.7665188 549.336643,51.2158787 L555.127131,57.0128464 L549.359535,62.7868968 C548.910677,63.2362567 548.910677,63.9331241 549.359535,64.382484 L550.6386,65.6629801 C551.087457,66.11234 551.783546,66.11234 552.232404,65.6629801 L558,59.8433197 L563.790488,65.6402874 C564.239346,66.0896473 564.935434,66.0896473 565.384292,65.6402874 L566.663357,64.3597913 C567.112214,63.9104314 567.112214,63.213564 566.663357,62.7642041 L560.850201,56.9901537 L566.640689,51.193186 C567.089547,50.7438261 567.089547,50.0469587 566.640689,49.5975988 L565.361625,48.3171028 C564.934694,47.8905703 564.216679,47.8905703 563.790623,48.3399213 L563.790488,48.3397954 Z"
        transform="translate(-549 -48)"
      />
    </svg>
  ),
  columns: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15">
      <path
        fill="#FFF"
        d="M15 2.699a.298.298 0 0 1-.298.301H.302A.3.3 0 0 1 0 2.699V.75C0 .337.337 0 .75 0h13.5c.413 0 .75.337.75.75v1.949zM3.449 4.5c.168 0 .301.133.301.301V14.7A.3.3 0 0 1 3.45 15H.75a.751.751 0 0 1-.75-.75V4.801A.3.3 0 0 1 .301 4.5H3.45zm1.801.301c0-.168.133-.301.301-.298H14.7a.3.3 0 0 1 .301.301v9.449c0 .413-.337.75-.75.75H5.551a.3.3 0 0 1-.301-.301v-9.9z"
      />
    </svg>
  ),
  columnsTable: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      viewBox="0 0 16 12"
    >
      <path
        fill="#9013FE"
        fillRule="evenodd"
        d="M833,20.4498997 C833,19.6489769 832.339639,19 831.524666,19 L818.475334,19 C817.660361,19 817,19.6489769 817,20.4498997 L817,29.5501003 C817,30.3510231 817.660361,31 818.475334,31 L831.524666,31 C832.339639,31 833,30.3510231 833,29.5501003 L833,20.4498997 Z M822.894684,30.1724495 L822.894684,19.8275505 L827.105232,19.8275505 L827.105232,30.1724495 L822.894684,30.1724495 Z M832.15789,20.4482445 L832.15789,29.5501003 C832.15789,29.8935924 831.874984,30.1724081 831.526308,30.1724081 L827.947342,30.1724081 L827.947342,19.8275092 L831.526308,19.8275092 C831.874984,19.8275092 832.15789,20.1055387 832.15789,20.4482031 L832.15789,20.4482445 Z M817.842025,20.4482445 C817.842025,20.10558 818.124932,19.8275505 818.473608,19.8275505 L822.052574,19.8275505 L822.052574,30.1724495 L818.473608,30.1724495 C818.124932,30.1724495 817.842025,29.8936131 817.842025,29.5501417 L817.842025,20.4482445 Z"
        transform="translate(-817 -19)"
      />
    </svg>
  ),
  contacts: (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14">
      <path
        fill="#FFF"
        d="M12.73 13.392H0v-1.793a1.26 1.26 0 0 1 .455-.976 20.596 20.596 0 0 1 3.732-2.394.115.115 0 0 0 .065-.104V6.892a2.91 2.91 0 0 1-.362-.99c-.139-.011-.32-.206-.517-.9-.269-.949.017-1.087.258-1.066a2.627 2.627 0 0 1-.105-.386 2.78 2.78 0 0 1 0-1.25 2.72 2.72 0 0 1 .73-1.28c.201-.213.428-.4.675-.557.202-.143.423-.256.656-.335a2.18 2.18 0 0 1 .596-.114 2.452 2.452 0 0 1 1.49.318c.3.155.553.39.729.677 0 0 1.21.087.8 2.543h.001c-.025.131-.06.26-.104.386.241-.023.527.118.258 1.067-.192.693-.385.888-.517.9v-.001c-.06.346-.183.677-.363.978V8.13c0 .043.026.084.066.104 1.326.66 2.577 1.46 3.731 2.388.29.241.458.6.455.976v1.793zm-.552-4.936v.718a.419.419 0 0 1-.062.226c.237.175.476.36.714.555.493.411.777 1.021.772 1.664v1.79H19v-1.694a1.348 1.348 0 0 0-.772-1.092 6.197 6.197 0 0 0-1.126-.432c-.022-.011-1.221-.326-1.791-.63l-.05-.03a.422.422 0 0 1-.193-.355v-.74s1.65.05 2.432-.75c0 0-1.138-.322-.934-2.396.204-2.074-.255-3.893-1.93-3.739 0 0-.72-.868-2.159-.322-.486.193-1.82.667-1.742 3.54.077 2.873-1.022 2.894-1.022 2.894s.559.81 2.465.793z"
      />
    </svg>
  ),
  copy: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
    >
      <path
        fill="#9013FE"
        d="M13.8857143,16.1142857 L11.8285714,16.1142857 L11.8285714,13.5428571 C11.8285714,12.6990994 11.129472,12 10.2857143,12 L1.54285714,12 C0.699099429,12 0,12.6990994 0,13.5428571 L0,24.3428571 C0,25.1866149 0.699099429,25.8857143 1.54285714,25.8857143 L3.6,25.8857143 L3.6,28.4571429 C3.6,29.3009006 4.29909943,30 5.14285714,30 L13.8857143,30 C14.729472,30 15.4285714,29.3009006 15.4285714,28.4571429 L15.4285714,17.6571429 C15.4285714,16.8133851 14.729472,16.1142857 13.8857143,16.1142857 Z M3.6,17.6571429 L3.6,24.3428571 L1.54285714,24.3428571 L1.54285714,13.5428571 L10.2857143,13.5428571 L10.2857143,16.1142857 L5.14285714,16.1142857 C4.29909943,16.1142857 3.6,16.8133851 3.6,17.6571429 Z M13.8857143,28.4571429 L5.14285714,28.4571429 L5.14285714,17.6571429 L13.8857143,17.6571429 L13.8857143,28.4571429 Z"
        transform="translate(0 -12)"
      />
    </svg>
  ),
  dashboard: (
    <svg width="20" height="12">
      <path
        d="M8.971 11.555c-1.005-.67-1.316-2.01-.67-3.038.67-1.029 6.46-8.278 7.488-7.632 1.029.646-3.134 8.971-3.78 10-.646 1.029-2.01 1.316-3.038.67zm7.56-8.229a.715.715 0 0 1 1.005.048A10.058 10.058 0 0 1 20 9.953a.705.705 0 0 1-.718.717.705.705 0 0 1-.717-.717 8.539 8.539 0 0 0-2.106-5.622c-.262-.287-.215-.741.072-1.005zM.718 10.693A.715.715 0 0 1 0 10C0 4.498 4.473 0 10 0c.98 0 1.961.144 2.918.43a.691.691 0 0 1 .479.886.691.691 0 0 1-.885.478A8.085 8.085 0 0 0 10 1.411c-4.713 0-8.565 3.852-8.565 8.565a.705.705 0 0 1-.717.717z"
        fill="#FFF"
      />
    </svg>
  ),
  directionalArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="83"
      viewBox="0 0 80 83"
    >
      <path
        fill="#F5A623"
        d="M750.942845,490.635919 C756.295302,486.026528 761.641815,481.87011 767.441896,477.707748 C767.145828,477.85868 767.441896,481.127044 767.441896,481.719119 C767.441896,482.311254 767.888895,485.283461 767.441896,485.73049 C764.469629,487.808699 761.497363,490.037899 758.525096,492.41809 C774.281081,489.892852 789.733895,484.836432 803.109094,476.22221 C810.243723,471.612819 816.635285,466.115315 821.981501,459.579003 C824.802776,456.159708 827.333958,452.444375 829.261176,448.433004 C830.30031,446.203804 831.339384,443.974604 831.937404,441.745404 C832.233472,440.555338 832.384404,439.516204 832.680471,438.326109 C832.233472,435.800871 833.12747,432.973651 832.680471,430.448413 C833.719605,437.287004 833.574469,445.309746 831.194338,451.84576 C828.518109,459.427418 823.467634,466.115017 817.97013,471.908559 C807.567197,482.758521 794.040412,490.333639 779.777991,495.09521 C774.727516,496.732335 769.671096,498.067477 764.620918,499.257572 C766.107051,500.151571 767.442193,501.190735 768.928326,502.078848 C769.224394,502.374915 768.928326,505.498143 768.928326,506.090219 C768.928326,506.537218 768.481327,509.805552 768.928326,510.10159 C763.134785,506.090219 757.190252,502.519932 750.943142,499.402619 C750.647074,499.251687 750.943142,496.279361 750.943142,495.536295 L750.943142,494.94416 C750.943142,494.055957 750.496143,491.083631 750.943142,490.636751 L750.942845,490.635919 Z"
        transform="rotate(-90 201.52 631.775)"
      />
    </svg>
  ),
  doubleDash: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="9"
      viewBox="0 0 16 9"
    >
      <g opacity=".3">
        <rect width="16" height="3" rx="1.5" />
        <rect width="16" height="3" y="6" rx="1.5" />
      </g>
    </svg>
  ),
  errorArrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="19"
      viewBox="0 0 12 19"
    >
      <path
        d="M4.90471318,26.3359586 C5.50998908,26.9546805 6.49004812,26.9546805 7.09532401,26.3359586 L14.584293,18.6683762 C15.1527774,18.0427246 15.1363154,17.069015 14.5465247,16.4651678 C13.955777,15.8603307 13.0047495,15.8434761 12.3946392,16.4255062 L5.99999628,22.9696165 L-0.394646615,16.4255062 C-1.00475698,15.8434634 -1.9557844,15.860318 -2.54653209,16.4651678 C-3.13631288,17.069015 -3.15277488,18.0426992 -2.58430047,18.6683762 L4.90471318,26.3359586 Z"
        transform="rotate(-90 0 15.4)"
      />
    </svg>
  ),
  export: (
    <svg width="12" height="16">
      <path
        d="M5.26 0h1.5v10.18l2.6-2.6 1.06 1.06L6 13.06 1.58 8.64l1.06-1.06 2.62 2.6V0zM0 14.5h12V16H0v-1.5z"
        fill="#9013FE"
      />
    </svg>
  ),
  expand: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g fill="#9013FE" fillRule="evenodd">
        <circle cx="14" cy="14" r="14" fillRule="nonzero" opacity=".1" />
        <g transform="translate(6 12)">
          <circle cx="7.75" cy="1.75" r="1.75" />
          <circle cx="13.75" cy="1.75" r="1.75" />
          <circle cx="1.75" cy="1.75" r="1.75" />
        </g>
        <g transform="translate(6 12)">
          <circle cx="7.75" cy="1.75" r="1.75" />
          <circle cx="13.75" cy="1.75" r="1.75" />
          <circle cx="1.75" cy="1.75" r="1.75" />
        </g>
      </g>
    </svg>
  ),
  google_analytics: (
    <svg width="22" height="22" viewBox="0 0 2195.9 2430.9">
      <path
        d="M2195.9,2126.7c.9,166.9-133.7,302.8-300.5,303.7a289,289,0,0,1-37.2-2.1c-154.8-22.9-268.2-157.6-264.4-314V316.1c-3.7-156.6,110-291.3,264.9-314,165.7-19.4,315.8,99.2,335.2,264.9a299.84,299.84,0,0,1,2,36.7Z"
        fill="#f9ab00"
      />
      <path
        d="M301.1,1828.7c166.3,0,301.1,134.8,301.1,301.1s-134.8,301.1-301.1,301.1S0,2296.1,0,2129.8,134.8,1828.7,301.1,1828.7Zm792.2-912.5c-167.1,9.2-296.7,149.3-292.8,316.6v808.7c0,219.5,96.6,352.7,238.1,381.1,163.3,33.1,322.4-72.4,355.5-235.7a294.74,294.74,0,0,0,6-60.7V1218.8c.3-166.9-134.7-302.4-301.6-302.7C1096.8,916.1,1095,916.1,1093.3,916.2Z"
        fill="#e37400"
      />
    </svg>
  ),
  // help: (<svg width="20" height="20"><path d="M17.077 2.923C13.181-.974 6.82-.974 2.923 2.923c-3.897 3.896-3.897 10.258 0 14.154 3.896 3.897 10.258 3.897 14.154 0 3.897-3.896 3.897-10.258 0-14.154zm1.432 9.9l-3.201-1.075c.379-1.137.379-2.38 0-3.517l3.201-1.075a9.293 9.293 0 0 1 0 5.667zM1.49 7.178l3.202 1.075a5.579 5.579 0 0 0 0 3.517L1.49 12.845a9.293 9.293 0 0 1 0-5.667zm5.308 6.024a4.552 4.552 0 0 1 0-6.424 4.552 4.552 0 0 1 6.424 0 4.552 4.552 0 0 1 0 6.424c-1.79 1.77-4.655 1.77-6.424 0zm6.024-11.711l-1.075 3.201a5.579 5.579 0 0 0-3.517 0L7.155 1.491a9.293 9.293 0 0 1 5.667 0zM7.177 18.51l1.075-3.202c1.137.38 2.38.38 3.517 0l1.075 3.202a9.293 9.293 0 0 1-5.667 0z" fill="#FFF" opacity=".9" /></svg>),
  installation: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="190"
      height="150"
      viewBox="0 0 190 150"
    >
      <g fill="none" fillRule="evenodd" transform="translate(-11 -26)">
        <path
          fill="#E9FEF9"
          d="M72.045891,21.6208333 C104.957532,17.1553077 144.588907,34.6113077 171.738918,59.6937521 C215.231564,99.874283 204.532264,144.860629 154.338907,164.143881 C104.145549,183.427132 79.3233021,180.237736 44.5498247,140.015599 C9.77634728,99.7934625 -3.03942994,31.8085788 72.045891,21.6208333 Z"
          transform="rotate(-15 107.935 98.258)"
        />
        <path
          fill="#52B8A0"
          fillRule="nonzero"
          d="M111.121 90.879C111.55069 90.879 111.97647 90.71494 112.3007 90.39072L140.0897 62.59772C140.73814 61.94928 140.73814 60.89072 140.0897 60.23832 139.44126 59.58988 138.3827 59.58988 137.7303 60.23832L109.9413 88.03132C109.29286 88.67976 109.29286 89.73832 109.9413 90.39072 110.26161 90.71103 110.6913 90.879 111.121 90.879zM116.609 97.059C116.93322 97.38322 117.36291 97.54728 117.7887 97.54728 118.21448 97.54728 118.64417 97.38322 118.9684 97.059L146.7614 69.266C147.40984 68.61756 147.40984 67.559 146.7614 66.9066 146.11296 66.25816 145.0544 66.25816 144.402 66.9066L116.609 94.6996C115.95666 95.35194 115.95666 96.4105 116.609 97.059z"
        />
        <path
          fill="#52B8A0"
          fillRule="nonzero"
          d="M140.512,149.047 C141.01981,148.82044 141.387,148.3595 141.48466,147.8126 C141.582316,147.26182 141.402629,146.6993 141.00028,146.3165 L129.51228,135.2305 C129.149,134.86722 128.94978,134.37503 128.94978,133.8438 C128.94978,133.30083 129.15681,132.793 129.55525,132.4063 L134.43025,127.5235 C135.22712,126.72662 136.43415,126.73053 137.22715,127.519593 L148.66115,138.957593 C149.05568,139.348213 149.61427,139.516183 150.15335,139.410713 C150.69632,139.309153 151.14944,138.945873 151.36815,138.434153 C154.57905,130.992753 152.90725,122.180153 147.20015,116.504153 C141.66495,111.000253 133.01615,109.051053 125.53615,111.605753 L119.28225,105.351853 C119.54397,105.176073 119.84866,105.066693 120.07913,104.840133 L154.54013,70.383133 C155.45029,69.469073 155.95033,68.262033 155.95033,66.972933 C155.95033,65.683833 155.45033,64.480733 154.54013,63.578433 L143.42313,52.457433 C141.59893,50.644933 138.43873,50.637133 136.61453,52.457433 L102.15353,86.918433 C101.92697,87.148903 101.82541,87.441873 101.65353,87.703593 L95.34883,81.320793 C97.85663,74.355993 95.7668,65.418793 90.37613,60.058793 C84.55973,54.277593 75.97813,52.660393 68.50513,55.902593 C67.99341,56.129153 67.62622,56.590093 67.52857,57.136993 C67.430914,57.687773 67.610601,58.250293 68.00904,58.633093 L79.50904,69.738093 C79.93873,70.163873 80.18092,70.738093 80.18092,71.347493 C80.18092,71.812333 80.01686,72.230303 79.70826,72.531093 L74.66526,77.581893 C73.9426,78.292833 72.61836,78.202983 71.77856,77.363143 L60.36056,66.011143 C59.95431,65.608803 59.36447,65.452553 58.82146,65.565833 C58.26287,65.694743 57.81366,66.089273 57.61836,66.624433 C56.57926,69.476033 56.05586,72.233833 56.05586,74.827533 C56.05586,79.925233 58.10666,84.765033 61.82536,88.456533 C67.36056,93.960433 76.00536,95.897933 83.48936,93.354933 L94.05936,103.920933 L71.35636,126.678933 L65.79776,130.014833 C65.58682,130.139833 65.40714,130.311713 65.27042,130.518743 L56.37592,143.862743 C55.93842,144.522903 56.02045,145.401843 56.58295,145.964343 L61.02435,150.409643 C61.34466,150.733863 61.77435,150.901833 62.20405,150.901833 C62.52436,150.901833 62.84467,150.811989 63.12983,150.624493 L76.46983,141.733893 C76.67686,141.597173 76.84874,141.417483 76.97374,141.206553 L80.05574,135.964353 L103.06774,112.952353 L113.65374,123.640353 C111.13034,130.745853 113.17327,139.488353 118.63424,144.890353 C122.45454,148.695053 127.48194,150.706753 132.59924,150.702853 C135.26724,150.69504 137.95474,150.152073 140.51334,149.046653 L140.512,149.047 Z M104.516,89.277 L138.977,54.816 C139.53559,54.2535 140.5161,54.25741 141.0629,54.816 L152.1839,65.933 C152.45734,66.20644 152.61749,66.57753 152.61749,66.976 C152.61749,67.37053 152.46515,67.74553 152.1839,68.0229 L117.7229,102.4799 C117.28931,102.90959 116.594,103.02287 116.0471,102.75334 C115.60179,102.5385 115.07054,102.56584 114.6213,102.772872 C114.17208,102.975992 113.82442,103.405682 113.69552,103.886172 C113.58615,104.284612 112.7424,106.370572 111.95722,108.206472 C111.39081,108.604912 110.55882,108.522882 110.07442,108.034592 L101.17992,99.140092 C101.17992,99.140092 101.172107,99.136186 101.172107,99.132279 L98.949407,96.909579 C98.675967,96.636139 98.515817,96.265049 98.515817,95.866579 C98.515817,95.561889 98.605661,95.265019 98.777537,95.026739 C100.609537,94.249399 102.687737,93.401739 103.043137,93.304039 C103.550947,93.214195 103.988447,92.878259 104.218937,92.417319 C104.453317,91.960289 104.457217,91.413419 104.230656,90.940719 C103.972846,90.386029 104.074406,89.710219 104.515816,89.276619 L104.516,89.277 Z M85.848,90.9997 C84.89488,90.05048 83.473,89.7224 82.2347,90.17939 C76.0667,92.35519 68.8127,90.72236 64.1757,86.10129 C61.0859,83.03489 59.3866,79.02709 59.3866,74.82829 C59.3866,73.39079 59.57801,71.88689 59.96472,70.32439 L69.42562,79.72669 C71.57792,81.87509 74.98812,81.95719 77.01942,79.94153 L82.05462,74.90243 C82.99603,73.98055 83.51552,72.71103 83.51552,71.33213 C83.51552,69.85163 82.90614,68.40633 81.83582,67.34773 L72.27332,58.11723 C77.84752,56.66803 83.81232,58.24223 88.02332,62.42583 C92.54282,66.91413 94.30062,74.38283 92.21082,80.17983 C91.75769,81.42593 92.0741,82.85173 93.02723,83.82043 L100.09363,90.88683 C99.28113,91.21105 98.33193,91.60167 97.12883,92.12123 C96.92571,92.203261 96.74602,92.32045 96.59758,92.47279 C95.68742,93.38685 95.18738,94.59389 95.18738,95.88299 C95.18738,97.17209 95.68738,98.37519 96.59758,99.27749 L97.64448,100.32439 L96.41008,101.55879 L85.848,90.9997 Z M77.4496,133.9257 L74.309,139.1679 L62.418,147.0898 L59.9063,144.5742 L67.836,132.6792 L73.3907,129.2925 L97.5357,105.1475 C97.551325,105.131874 97.578669,105.127968 97.5982,105.104531 C97.617732,105.085 97.621638,105.061562 97.641169,105.042031 L100.004469,102.678731 L104.316969,106.991231 L101.941969,109.370131 C101.930251,109.381849 101.914625,109.385756 101.899001,109.397475 C101.887282,109.409193 101.883375,109.424818 101.871657,109.440443 L77.4496,133.9257 Z M120.9926,142.5195 C116.4887,138.0625 114.727,130.5895 116.8051,124.7465 C117.2426,123.4965 116.92619,122.0785 115.9926,121.1332 L105.4416,110.5822 L106.676,109.3478 L107.7229,110.3908 C108.63306,111.30096 109.8401,111.7931 111.1213,111.7931 C112.4065,111.7931 113.6135,111.29701 114.5158,110.3908 C114.66424,110.24236 114.78533,110.06268 114.87518,109.86736 C115.3908,108.65646 115.78924,107.69936 116.11348,106.89076 L123.19158,113.96496 C124.13299,114.90246 125.55488,115.21886 126.79708,114.77355 C132.96508,112.60165 140.21908,114.25011 144.85608,118.85555 C148.99668,122.97665 150.58268,129.08955 149.13338,134.70355 L139.58258,125.14885 C137.48098,123.05905 134.19198,123.05905 132.07478,125.156662 L127.20758,130.031662 C126.18418,131.035562 125.61778,132.387162 125.61778,133.836362 C125.61778,135.262162 126.16856,136.590262 127.18418,137.598062 L136.73888,146.824662 C131.17248,148.309062 125.19988,146.715282 120.99288,142.519962 L120.9926,142.5195 Z"
        />
      </g>
    </svg>
  ),
  loader: (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="#333"
        strokeWidth="4"
        r="24"
        strokeDasharray="113.09733552923255 39.69911184307752"
        transform="rotate(132 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
  lightbulb: (
    <svg width="23" height="25">
      <path
        d="M11.2.92c-.264 0-.56.283-.56.56v1.68a.582.582 0 0 0 .56.568.582.582 0 0 0 .56-.568V1.48c0-.318-.296-.56-.56-.56zm7.49 3.351a.565.565 0 0 0-.324.167l-1.12 1.12a.582.582 0 0 0-.012.8c.21.21.593.21.8-.004l1.12-1.12a.573.573 0 0 0 .139-.621.575.575 0 0 0-.533-.35.51.51 0 0 0-.07.008zm-15.586.374c-.07.202-.01.441.142.589l1.12 1.12c.207.213.59.214.8.003a.582.582 0 0 0-.012-.8l-1.12-1.12a.57.57 0 0 0-.455-.166.572.572 0 0 0-.475.374zM11.2 5.96c-3.13 0-6.16 2.552-6.16 6.16 0 4.402 2.97 5.053 3.325 7.84h5.67c.354-2.787 3.325-3.438 3.325-7.84 0-3.608-3.03-6.16-6.16-6.16zm8.12 6.44c0 .264.266.56.56.56h1.96a.575.575 0 0 0 .56-.56.575.575 0 0 0-.56-.56h-1.96c-.323 0-.56.296-.56.56zM0 12.4c0 .264.267.56.56.56h1.68a.582.582 0 0 0 .568-.56.582.582 0 0 0-.568-.56H.56c-.322 0-.56.296-.56.56zm4.725 5.618l-1.444 1.435a.582.582 0 0 0-.012.8c.21.21.593.21.8-.004l1.444-1.444a.575.575 0 0 0 .126-.619.574.574 0 0 0-.529-.343.566.566 0 0 0-.385.175zm12.02.199c-.07.2-.01.44.143.588l1.443 1.444c.207.213.59.214.8.003a.582.582 0 0 0-.012-.8l-1.444-1.434a.566.566 0 0 0-.455-.175.572.572 0 0 0-.475.374zM8.4 21.08v2.8c0 .643.53 1.12 1.12 1.12h3.36c.59 0 1.12-.477 1.12-1.12v-2.8H8.4z"
        fill="#000"
        opacity=".3"
      />
    </svg>
  ),
  oval: (
    <svg width="190" height="150">
      <path
        d="M42.295 7.437C72.93-5.395 115.73 1.209 148.445 18.41c52.41 27.555 53.72 73.777 10.227 105.395-43.492 31.617-68.294 34.96-112.293 5.11C2.38 99.061-27.595 36.71 42.295 7.436z"
        fill="#E9FEF9"
      />
    </svg>
  ),
  person: (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36">
      <path
        d="M18.018 19.285c8.743 0 17.685 1.76 17.685 14.854v.807A1.061 1.061 0 0 1 34.642 36H1.394C.81 36 .337 35.53.333 34.946v.002-.807c0-13.76 7.662-14.856 17.685-14.856zm0-1.414a8.952 8.952 0 0 1-6.311-2.622 8.935 8.935 0 0 1 .002-12.632 8.935 8.935 0 0 1 12.636.003 8.942 8.942 0 0 1 2.615 6.32 8.94 8.94 0 0 1-8.942 8.93z"
        opacity=".2"
      />
    </svg>
  ),
  phone: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill="#FFF"
        d="M9.57560753,15.3000245 C7.86047343,13.8898026 6.71495377,12.1494796 6.11334603,11.1596384 L5.6640018,10.3130996 C5.82147256,10.1445955 7.01804287,8.86277043 7.53761318,8.16667203 C8.18957315,7.29306981 7.24474345,6.50368754 7.24474345,6.50368754 C7.24474345,6.50469048 4.5838553,3.84382646 3.97788251,3.31616795 C3.37206378,2.78758507 2.67398825,3.08146647 2.67398825,3.08146647 C1.40018723,3.90492187 0.0793462788,4.62107387 4.92596427e-06,8.06328177 C-0.0040070761,11.2859786 2.44330776,14.6098421 5.08914931,17.1836858 C7.73899643,20.0903011 11.3779144,23.0030788 14.895381,22.9999976 C18.3376146,22.9217629 19.0527139,21.6008167 19.8761693,20.3260142 C19.8761693,20.3260142 20.1700404,19.6289401 19.6414678,19.02212 C19.1128849,18.4152998 16.4518941,15.754232 16.4518941,15.754232 C16.4518941,15.754232 15.6635389,14.8084009 14.789911,15.4613622 C14.1389524,15.9478095 12.9694763,17.0310628 12.6876219,17.292838 C12.6886251,17.2948438 10.7327691,16.2517202 9.57533535,15.2998807 L9.57560753,15.3000245 Z"
        transform="translate(0 -3)"
      />
    </svg>
  ),
  plus: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>plus</title>
      <path
        d="M8.99 2c.703 0 1.258.555 1.258 1.258v4.494h4.494c.684 0 1.258.555 1.258 1.239 0 .702-.573 1.257-1.258 1.257h-4.494v4.494A1.26 1.26 0 0 1 8.991 16c-.684 0-1.24-.573-1.24-1.258v-4.494H3.259A1.248 1.248 0 0 1 2 8.991c0-.684.555-1.24 1.258-1.24h4.494V3.259C7.752 2.555 8.307 2 8.99 2z"
        fill="#9013FE"
        fillRule="evenodd"
      />
    </svg>
  ),
  question: (
    <svg width="12" height="18">
      <path
        d="M8.101.38c.66.24 1.26.62 1.78 1.1.54.5.96 1.08 1.26 1.72.3.66.46 1.38.46 2.1 0 .72-.16 1.44-.46 2.1-.3.64-.74 1.12-1.32 1.68-.34.34-1.3 1.04-1.92 2.22-.56 1.06-1.12 2.1-1.84 2.1-.74 0-1.36-1-1.04-2.16.74-2.64 2.66-3.84 3.02-4.12.38-.34.54-.56.7-.8.18-.3.22-.66.22-1.02s-.08-.7-.22-1.02c-.16-.32-.36-.62-.64-.86a2.85 2.85 0 0 0-.94-.58c-.34-.14-.72-.2-1.1-.2-.38 0-.74.06-1.1.2-.36.14-.66.34-.94.58-.16.14-.42.46-.6.86-.259.54-.859 1.02-1.58 1.02-.72 0-1.32-.5-1.2-1.08.08-.34.18-.68.34-1.02.3-.66.721-1.22 1.26-1.72.52-.48 1.12-.84 1.78-1.1.64-.26 1.34-.38 2.04-.38s1.38.12 2.04.38zm-.36 15.98C7.74 17.26 7 18 6.1 18c-.9 0-1.64-.74-1.64-1.64 0-.9.74-1.64 1.64-1.64.9 0 1.64.74 1.64 1.64z"
        fill="#000"
        opacity=".5"
      />
    </svg>
  ),
  questionMark: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none">
        <path
          fill="#959595"
          d="M7.9367619,1.58779048 C11.4285714,1.58779048 14.2857143,4.44493333 14.2857143,7.93674286 C14.2857143,11.4285524 11.4285714,14.2856952 7.9367619,14.2856952 C4.44495238,14.2856952 1.58780952,11.4285524 1.58780952,7.93674286 C1.58780952,4.44493333 4.44495238,1.58779048 7.9367619,1.58779048 Z M7.9367619,-2.78972612e-13 C3.57142857,-2.78972612e-13 6.28830321e-13,3.57142857 6.28830321e-13,7.9367619 C6.28830321e-13,12.3020952 3.57142857,15.8735238 7.9367619,15.8735238 C12.3020952,15.8735238 15.8735238,12.3020952 15.8735238,7.9367619 C15.8735238,3.57142857 12.3020952,-2.80664381e-13 7.9367619,-2.78972612e-13 Z"
        />
        <path
          fill="#959595"
          d="M7.58706095,9.55506552 C7.58706095,8.44420838 8.06325143,8.04687505 8.45982286,7.65030362 C8.6979181,7.49182171 8.85639429,7.25373219 8.93601333,7.01563695 C9.09449524,6.77754171 9.09449524,6.53944648 9.09449524,6.22173219 C9.09449524,5.9040179 9.0148819,5.66592267 8.8564,5.42782743 C8.6979181,5.26934552 8.53868571,5.11011314 8.22173333,5.11011314 C7.9836381,5.11011314 7.42782857,5.18972648 7.42782857,6.30058933 L6,6.30133333 L6,5.98361905 C6,5.26933333 6.23809524,4.79314286 6.63466667,4.39657143 C7.11085714,4.15847619 7.66666667,4 8.30133333,4 C9.0952381,4 9.65028571,4.1584819 10.047619,4.63466667 C10.4441905,5.11085714 10.6822857,5.58704762 10.6822857,6.22171429 C10.6822857,8.12647619 9.0952381,8.20609524 9.0952381,9.55504762 L7.58706095,9.55506552 Z"
        />
        <polygon fill="#188BFF" points="9.587 11.587 8 11.587 8 10 9.587 10" />
      </g>
    </svg>
  ),
  reset: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.347 3.006l.956.954a.388.388 0 0 1-.27.666h-.864a.366.366 0 0 1-.27-.108L1.972 2.592c-.144-.145-.144-.396 0-.559L3.898.107A.37.37 0 0 1 4.168 0h.865c.342 0 .521.414.27.666l-.974.974H9.19c4.519 0 8.19 3.671 8.19 8.189 0 4.5-3.671 8.171-8.19 8.171C4.673 18 1 14.328 1 9.81a.684.684 0 1 1 1.367 0 6.83 6.83 0 0 0 6.822 6.82 6.83 6.83 0 0 0 6.822-6.82c0-3.763-3.058-6.804-6.82-6.804H4.346zm7.845 9.9a.486.486 0 0 1-.685 0L9.55 10.95a.486.486 0 0 0-.687 0l-1.937 1.936a.486.486 0 0 1-.686 0l-.418-.418a.486.486 0 0 1 0-.685L7.76 9.845a.486.486 0 0 0 0-.685L5.823 7.223a.486.486 0 0 1 0-.685l.432-.432a.486.486 0 0 1 .686 0l1.937 1.937c.19.188.495.188.685 0L11.5 6.106a.486.486 0 0 1 .685 0l.418.418c.189.19.189.496 0 .686l-1.936 1.937a.486.486 0 0 0 0 .686l1.956 1.956c.19.19.19.497 0 .686l-.432.431z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  ),

  salesforce: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>salesforce</title>
      <path
        d="M7.49 4.374a3.154 3.154 0 0 1 2.283-.98c1.188 0 2.225.663 2.777 1.646a3.84 3.84 0 0 1 1.57-.333c2.142 0 3.88 1.752 3.88 3.914s-1.738 3.915-3.88 3.915c-.257 0-.513-.025-.765-.076a2.837 2.837 0 0 1-3.717 1.167 3.236 3.236 0 0 1-6.016-.146c-.203.043-.41.064-.618.064C1.345 13.545 0 12.186 0 10.51a3.04 3.04 0 0 1 1.502-2.63A3.496 3.496 0 0 1 7.49 4.374"
        fill="#139CD8"
        fillRule="evenodd"
      />
    </svg>
  ),
  segment: (
    <svg width="22" height="22" viewBox="0 0 256 238">
      <path
        d="M159.58,162.38H12.29a12.3,12.3,0,0,1,0-24.59H159.58a12.3,12.3,0,0,1,0,24.59Zm84.13-62.46H96.43a12.29,12.29,0,1,1,0-24.58H243.71a12.29,12.29,0,0,1,0,24.58ZM213.26,40.78A12.3,12.3,0,1,1,201,28.49,12.3,12.3,0,0,1,213.26,40.78ZM67.33,197A12.3,12.3,0,1,1,55,184.65,12.3,12.3,0,0,1,67.33,197Z"
        fill="#93c8a2"
      />
      <path
        d="M127.93,237.52a118.88,118.88,0,0,1-35.2-5.3A12.29,12.29,0,0,1,100,208.74a94.3,94.3,0,0,0,118-62.39,12.29,12.29,0,0,1,23.5,7.19A118.15,118.15,0,0,1,127.93,237.52ZM26.11,99.84A12.29,12.29,0,0,1,14.36,84,118.89,118.89,0,0,1,163.13,5.31a12.29,12.29,0,1,1-7.27,23.47,94.87,94.87,0,0,0-27.93-4.18A93.69,93.69,0,0,0,37.85,91.19a12.3,12.3,0,0,1-11.74,8.7Z"
        fill="#43af79"
      />
    </svg>
  ),
  send: (
    <svg width="16" height="16">
      <path
        d="M.439 7.86L15.178.13c.606-.317.954-.037.775.623l-3.181 11.695c-.18.66-.858.964-1.492.706l-2.088-.85c-.634-.258-1.673-.672-2.311-.919l-.22-.085c-.639-.247-.777-.858-.309-1.357l6.462-6.915c.466-.5.409-.562-.129-.14L4.512 9.335c-.54.42-1.502.558-2.137.305L.493 8.895c-.635-.251-.66-.717-.054-1.035zm5.165 7.656c.038-.114-1.302-3.344-1.301-3.345-.262-.632.041-.936.674-.677l1.444.591c.632.26.845.942.47 1.514 0 0-1.324 2.028-1.287 1.917z"
        fill="#9013FE"
      />
    </svg>
  ),
  share: (
    <svg width="14" height="12">
      <path
        d="M13.295.012a.837.837 0 0 1 .395.18.753.753 0 0 1 .245.328.814.814 0 0 1 .065.318V4.566a.87.87 0 0 1-.242.592c-.15.163-.374.234-.587.244a.835.835 0 0 1-.587-.244.873.873 0 0 1-.242-.592V2.86L8.816 6.414a.851.851 0 0 1-.587.244c-.223.01-.43-.1-.587-.244a.855.855 0 0 1-.242-.592c0-.216.09-.44.242-.592l.008-.008c.197-.205.4-.404.601-.606L9.486 3.37l1.428-1.439.256-.258H9.472a.87.87 0 0 1-.587-.244c-.162-.152-.232-.377-.242-.592a.848.848 0 0 1 .242-.592.859.859 0 0 1 .587-.244h3.699c.042 0 .083.003.124.01zm-.954 8.147c0-.226.094-.428.242-.597.15-.163.374-.234.587-.244a.835.835 0 0 1 .587.244c.15.152.242.378.242.592v2.238c0 .333-.11.644-.335.89-.229.249-.555.377-.889.384H1.23a1.249 1.249 0 0 1-.848-.338A1.263 1.263 0 0 1 0 10.43c-.003-.232 0-.464 0-.697V1.334c0-.263.039-.528.186-.752C.426.219.797.008 1.23 0h4.677c.225 0 .424.094.586.244.163.152.233.376.242.592a.848.848 0 0 1-.242.591.859.859 0 0 1-.587.244H1.668c-.165 0-.332-.01-.494.004l.22-.03a.452.452 0 0 0-.106.028l.197-.084a.695.695 0 0 0-.074.044c.056-.044.11-.087.167-.13a.44.44 0 0 0-.078.074l.13-.168a.465.465 0 0 0-.055.093c.026-.065.055-.132.083-.199a.49.49 0 0 0-.028.108l.03-.222a.562.562 0 0 0-.004.06c-.003.369 0 .739 0 1.108V10.2c0 .094-.004.189.004.282l-.03-.222a.456.456 0 0 0 .028.109l-.083-.2a.528.528 0 0 0 .054.094l-.13-.168a.475.475 0 0 0 .06.061c-.055-.043-.11-.087-.167-.13.029.021.059.04.092.055l-.198-.084c.035.013.07.023.106.028l-.22-.03c.022.003.042.003.063.003.148.002.296 0 .443 0H12.48c.114 0 .231.007.345-.003l-.22.03a.452.452 0 0 0 .106-.028l-.198.084a.511.511 0 0 0 .092-.055c-.056.043-.11.087-.167.13a.74.74 0 0 0 .06-.061l-.13.168c.021-.03.04-.06.055-.093l-.083.199a.53.53 0 0 0 .028-.109l-.03.222c.01-.103.003-.21.003-.315v-2.01z"
        fill="#9013FE"
      />
    </svg>
  ),
  // signout: (<svg width="14" height="18"><path d="M13.736 10.47c0-.924-.748-1.672-1.67-1.67h-.494l-.002-3.938A4.87 4.87 0 0 0 6.705 0a4.872 4.872 0 0 0-4.863 4.866l.003 3.938H1.67C.748 8.806 0 9.554 0 10.476l.004 5.854c0 .922.748 1.67 1.67 1.67l10.396-.006a1.67 1.67 0 0 0 1.67-1.67l-.004-5.854zM3.638 8.804l-.002-3.938a3.075 3.075 0 0 1 3.068-3.074 3.079 3.079 0 0 1 3.074 3.07L9.78 8.8l-6.142.004z" fill="#000" opacity=".5" /></svg>),
  slack: (
    <svg viewBox="-101 331 132 132" width="28" height="28" aria-label="Slack">
      <path
        d="M-16.7 343.1c-1.9-5.7-8-8.8-13.7-7-5.7 1.9-8.8 8-7 13.7l28.1 86.4c1.9 5.3 7.7 8.3 13.2 6.7 5.8-1.7 9.3-7.8 7.4-13.4 0-.2-28-86.4-28-86.4z"
        fill="#ECB32D"
      />
      <path
        d="M-60.2 357.2c-1.9-5.7-8-8.8-13.7-7-5.7 1.9-8.8 8-7 13.7l28.1 86.4c1.9 5.3 7.7 8.3 13.2 6.7 5.8-1.7 9.3-7.8 7.4-13.4 0-.2-28-86.4-28-86.4z"
        fill="#63C1A0"
      />
      <path
        d="M18.7 414.6c5.7-1.9 8.8-8 7-13.7-1.9-5.7-8-8.8-13.7-7l-86.5 28.2c-5.3 1.9-8.3 7.7-6.7 13.2 1.7 5.8 7.8 9.3 13.4 7.4.2 0 86.5-28.1 86.5-28.1z"
        fill="#E01A59"
      />
      <path
        d="M-56.5 439.1c5.6-1.8 12.9-4.2 20.7-6.7-1.8-5.6-4.2-12.9-6.7-20.7l-20.7 6.7 6.7 20.7z"
        fill="#331433"
      />
      <path
        d="M-12.9 424.9c7.8-2.5 15.1-4.9 20.7-6.7-1.8-5.6-4.2-12.9-6.7-20.7l-20.7 6.7 6.7 20.7z"
        fill="#D62027"
      />
      <path
        d="M4.5 371.1c5.7-1.9 8.8-8 7-13.7-1.9-5.7-8-8.8-13.7-7l-86.4 28.1c-5.3 1.9-8.3 7.7-6.7 13.2 1.7 5.8 7.8 9.3 13.4 7.4.2 0 86.4-28 86.4-28z"
        fill="#89D3DF"
      />
      <path
        d="M-70.6 395.5c5.6-1.8 12.9-4.2 20.7-6.7-2.5-7.8-4.9-15.1-6.7-20.7l-20.7 6.7 6.7 20.7z"
        fill="#258B74"
      />
      <path
        d="M-27.1 381.4c7.8-2.5 15.1-4.9 20.7-6.7-2.5-7.8-4.9-15.1-6.7-20.7l-20.7 6.7 6.7 20.7z"
        fill="#819C3C"
      />
    </svg>
  ),
  // switch: (<svg width="20" height="15"><path d="M6.853 6.173c-.779-1.366-1.496-2.155-2.55-2.155H0V1.953h4.304c1.665 0 2.799.925 3.683 2.155-.435.687-.802 1.406-1.134 2.065zm7.975 4.385V8.605l5.17 2.986-5.17 2.984v-1.952h-1.923c-1.665 0-2.8-.925-3.684-2.155.436-.687.802-1.406 1.135-2.065.778 1.366 1.496 2.155 2.55 2.155h1.922zm-1.922-6.54c-1.41 0-2.218 1.41-3.377 3.731-1.143 2.286-2.437 4.874-5.227 4.874H0v-2.065h4.302c1.41 0 2.219-1.41 3.378-3.731 1.143-2.286 2.437-4.874 5.226-4.874h1.922V0L20 2.986 14.828 5.97V4.018h-1.922z" fill="#000" opacity=".3" /></svg>),
  team: (
    <svg width="99" height="77">
      <g fill="#4BE0BF">
        <path d="M70.129 76.344a2.762 2.762 0 0 0 2.762-2.762V45.81c0-5.722-2.797-10.62-7.743-13.832 2.317-3.218 3.704-7.156 3.704-11.418C68.852 9.762 60.066.977 49.266.977c-10.797 0-19.578 8.785-19.578 19.582 0 4.313 1.418 8.29 3.785 11.527-4.828 3.18-7.559 8.047-7.559 13.723v27.773a2.762 2.762 0 1 0 5.524 0V45.81c0-4.191 2.09-7.504 6.011-9.672 3.29 2.504 7.375 4.004 11.816 4.004 4.496 0 8.63-1.535 11.938-4.093 3.973 2.187 6.164 5.605 6.164 9.757v27.773a2.765 2.765 0 0 0 2.762 2.766zM35.207 20.559c0-7.754 6.305-14.059 14.055-14.059 7.754 0 14.062 6.305 14.062 14.059s-6.309 14.062-14.062 14.062c-7.75 0-14.055-6.309-14.055-14.062z" />
        <path d="M2.938 60.297a2.76 2.76 0 0 0 2.761-2.762l-.004-16.12c0-1.926.79-3.38 2.39-4.423a12.669 12.669 0 0 0 7.11 2.168c7.055 0 12.79-5.734 12.79-12.777 0-7.046-5.735-12.785-12.79-12.785-7.043 0-12.773 5.735-12.773 12.785 0 2.407.68 4.657 1.844 6.579-2.644 2.054-4.09 4.968-4.09 8.456v16.126a2.755 2.755 0 0 0 2.762 2.753zm12.257-41.18c4.008 0 7.266 3.258 7.266 7.262 0 4-3.262 7.257-7.265 7.257-4 0-7.254-3.257-7.254-7.257-.004-4.004 3.253-7.262 7.253-7.262zM83.441 13.598c-7.047 0-12.781 5.734-12.781 12.785 0 7.047 5.734 12.777 12.781 12.777 2.664 0 5.144-.82 7.195-2.227 1.653 1.055 2.465 2.524 2.465 4.485v16.12a2.762 2.762 0 1 0 5.523 0v-16.12c0-3.54-1.48-6.485-4.19-8.547a12.691 12.691 0 0 0 1.784-6.488c.004-7.051-5.73-12.785-12.777-12.785zm-7.258 12.781c0-4.004 3.258-7.262 7.258-7.262 4.004 0 7.258 3.258 7.258 7.262 0 4-3.25 7.258-7.258 7.258-4.004 0-7.258-3.258-7.258-7.258z" />
      </g>
    </svg>
  ),
  tip: (
    <svg width="16" height="16">
      <g fill="#959595">
        <path d="M8 1.651c3.492 0 6.349 2.857 6.349 6.349S11.492 14.349 8 14.349 1.651 11.492 1.651 8 4.508 1.651 8 1.651zM8 .063C3.635.063.063 3.635.063 8S3.635 15.937 8 15.937 15.937 12.365 15.937 8 12.365.063 8 .063z" />
        <path d="M7.206 9.587c0-1.11.476-1.508.873-1.905.238-.158.396-.396.476-.634.159-.238.159-.477.159-.794 0-.318-.08-.556-.239-.794-.158-.159-.317-.318-.634-.318-.238 0-.794.08-.794 1.19l-1.428.001v-.317c0-.715.238-1.19.635-1.587a3.69 3.69 0 0 1 1.666-.397c.794 0 1.35.158 1.747.635.396.476.634.952.634 1.587 0 1.904-1.587 1.984-1.587 3.333H7.206zM8.794 11.968H7.207v-1.587h1.587z" />
      </g>
    </svg>
  ),
  totango: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>totango</title>
      <g transform="translate(1)" fill="none" fillRule="evenodd">
        <ellipse fill="#40AD90" cx="13.178" cy="2.585" rx="2.581" ry="2.585" />
        <ellipse fill="#65D45B" cx="2.922" cy="15.07" rx="2.577" ry="2.591" />
        <ellipse fill="#40AD90" cx="6.985" cy="3.206" rx="2.133" ry="2.137" />
        <ellipse fill="#65D45B" cx="2.144" cy="8.826" rx="2.126" ry="2.138" />
        <ellipse fill="#40AD90" cx="13.867" cy="8.756" rx="2.133" ry="2.137" />
        <ellipse fill="#65D45B" cx="9.06" cy="14.393" rx="2.143" ry="2.155" />
        <ellipse fill="#40AD90" cx="1.789" cy="3.689" rx="1.514" ry="1.517" />
        <ellipse fill="#65D45B" cx="14.282" cy="13.944" rx="1.545" ry="1.554" />
      </g>
    </svg>
  ),
  trash: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Combined Shape</title>
      <path
        d="M4.992 16.011L3.71 5.68h10.657l-1.283 10.332a1.133 1.133 0 0 1-1.125.989H6.117c-.57 0-1.053-.423-1.125-.989zM12.57 2.698h2.52v2.226H3V2.698h2.51l.03-.328C5.615 1.592 6.26 1 7.04 1h3.997c.78 0 1.426.592 1.502 1.37l.03.328zm-6.306 0h5.544l-.023-.256a.757.757 0 0 0-.751-.687H7.038a.757.757 0 0 0-.751.687l-.023.256z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  ),
  warning: (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Shape</title>
      <path
        d="M13.816 10.449L8.284.727C8.03.27 7.556 0 7.004 0 6.45 0 5.991.269 5.721.727L.19 10.45a1.518 1.518 0 0 0 0 1.47c.253.458.727.727 1.264.727h11.05c.537 0 1.01-.268 1.264-.727.3-.459.3-1.012.048-1.47zm-6.006-.111H6.34v-1.28h1.47v1.28zm0-2.023H6.34V4.647h1.47v3.668z"
        fill="#F5A623"
        fillRule="nonzero"
      />
    </svg>
  ),
  warningLarge: (
    <svg
      width="32"
      height="28"
      viewBox="0 0 14 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Shape</title>
      <path
        d="M13.816 10.449L8.284.727C8.03.27 7.556 0 7.004 0 6.45 0 5.991.269 5.721.727L.19 10.45a1.518 1.518 0 0 0 0 1.47c.253.458.727.727 1.264.727h11.05c.537 0 1.01-.268 1.264-.727.3-.459.3-1.012.048-1.47zm-6.006-.111H6.34v-1.28h1.47v1.28zm0-2.023H6.34V4.647h1.47v3.668z"
        fill="#F5A623"
        fillRule="nonzero"
      />
    </svg>
  ),
  x: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>X v2</title>
      <path
        d="M6 7.554l-4.247 4.247c-.326.326-.938.243-1.368-.186-.429-.43-.512-1.042-.186-1.368L4.446 6 .199 1.753C-.127 1.427-.044.815.385.385.815-.044 1.427-.127 1.753.2L6 4.446 10.247.199c.326-.326.938-.243 1.368.186.429.43.512 1.042.186 1.368L7.554 6l4.247 4.247c.326.326.243.938-.186 1.368-.43.429-1.042.512-1.368.186L6 7.554z"
        fill="#000"
        fillRule="nonzero"
      />
    </svg>
  ),
  zendesk: (
    <svg width="22" height="22" viewBox="0 0 205.41 158.2">
      <polygon points="95 42.93 95 155.79 1.52 155.79 95 42.93" />
      <path d="M95,2.42a46.74,46.74,0,0,1-93.48,0Z" />
      <path d="M110.4,155.79a46.74,46.74,0,0,1,93.48,0Z" />
      <polygon points="110.4 115.28 110.4 2.42 203.89 2.42 110.4 115.28" />
    </svg>
  ),
  gauge: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M17.8767949,9.23308312 L17.8767706,9.23298733 C18.6031875,8.85039387 19.4752752,9.13758442 19.8375393,9.83165018 C20.5885575,11.2452129 21,12.849342 21,14.4535669 C21,15.2439934 20.3464185,15.8903577 19.5471662,15.8903577 C18.747914,15.8903577 18.0943325,15.2439934 18.0943325,14.4535669 C18.0943325,13.3039905 17.8039595,12.1786959 17.2714475,11.1731339 C16.908239,10.4781103 17.1749793,9.59228083 17.8767949,9.23308312 Z M12.1630418,7.53359901 L12.1630418,7.53358464 C11.7752321,7.46155832 11.3883909,7.43723824 11.0005811,7.43723824 C7.10165962,7.43723824 3.9056675,10.5747105 3.9056675,14.4538063 C3.9056675,15.2442329 3.25208603,15.8905972 2.45283375,15.8905972 C1.65358148,15.8905972 1,15.2442329 1,14.4538063 C1,8.99376165 5.47957074,4.56367906 11.0005811,4.56461441 C11.5330931,4.56461441 12.0902064,4.58893449 12.6227184,4.68434698 C13.4219707,4.80407955 13.9544827,5.54584677 13.8334132,6.33627331 C13.7123438,7.12669984 12.9622941,7.65333158 12.1630418,7.53359901 Z M18.5550261,4.08458259 L18.5549777,4.0847981 C18.7006388,4.20453068 18.7242861,4.39627999 18.6514555,4.54033264 L12.1865874,15.2918385 C11.7751449,15.9868574 10.8784559,16.2019976 10.1766404,15.7950985 C9.4738611,15.3881993 9.25631862,14.501412 9.66776113,13.8073462 C9.7169444,13.7353199 9.76518332,13.6876137 9.81342225,13.6155873 L18.0461468,4.13228883 C18.1672163,3.96485002 18.409365,3.96485002 18.5550261,4.08458259 Z" />
    </svg>
  ),
  customers: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M21,17.2803628 L21,19 L1,19 L1,16.2962854 C1.05352311,15.7493075 1.38105463,15.272048 1.86436189,15.0366932 C2.27177725,14.8308611 2.69675961,14.6652185 3.13452355,14.543017 C3.15928709,14.5307163 4.50693784,14.1649714 5.14922748,13.8164632 L5.19635981,13.7869426 C5.33456036,13.6950973 5.41603935,13.5360108 5.41284906,13.3670785 L5.41284906,12.5486795 C3.26963404,12.5675406 2.63996237,11.6253145 2.63996237,11.6253145 C2.63996237,11.6253145 3.86699388,11.6064535 3.78950684,8.28928456 C3.71201775,4.97214853 5.20267902,4.42443586 5.75866744,4.20799593 C7.37634488,3.57819984 8.18798532,4.57947066 8.18798532,4.57947066 C10.0612943,4.40070094 10.5788562,6.50249006 10.3496058,8.89777255 C10.120335,11.293097 11.4008855,11.6646767 11.4008855,11.6646767 C10.5213493,12.5880418 8.66480976,12.5298276 8.66480976,12.5298276 L8.66480976,13.3695557 L8.66401096,13.3695557 C8.66081557,13.5384859 8.74309723,13.6975745 8.88129779,13.7894198 L8.93881489,13.8255029 C9.57869137,14.1740321 10.9287532,14.5389359 10.9535188,14.5520567 L10.9527198,14.5512365 C11.203566,14.6209402 11.4504038,14.7054064 11.6908611,14.8054432 C12.347507,14.4003373 12.8563774,14.1354661 13.0265258,14.0518292 C13.0640709,14.032968 13.0880369,13.9936066 13.0880369,13.9509631 L13.0880369,12.7586122 C12.9202791,12.465862 12.805247,12.144393 12.7501328,11.8098244 C12.6215174,11.7991638 12.4513711,11.6121922 12.2676231,10.9487671 C12.0159794,10.0401603 12.2836001,9.89910698 12.508878,9.92616722 L12.508878,9.92698742 C12.4665393,9.80480068 12.4337857,9.68014934 12.4106193,9.55305649 C12.3219479,9.1586152 12.3219479,8.74859695 12.4106193,8.35415565 C12.5240564,7.88919819 12.7597098,7.46521946 13.0920308,7.12819458 C13.2789609,6.92318335 13.4906525,6.74359909 13.7215185,6.59269995 C13.9108453,6.45657162 14.1169498,6.34831807 14.3350342,6.27207076 C14.5131767,6.21138781 14.6985014,6.17694636 14.8854396,6.16874431 C15.370342,6.11462174 15.8600299,6.22040649 16.2818219,6.47134034 C16.5622191,6.61976859 16.7978705,6.84445254 16.9632334,7.11998833 C16.9632334,7.11998833 18.0920002,7.20199198 17.7117636,9.55708928 C17.6885972,9.68419683 17.6558436,9.80883978 17.6135049,9.93102022 C17.8387879,9.90969952 18.1039903,10.0441862 17.8547598,10.9536201 C17.6710241,11.6195035 17.5008634,11.8040128 17.3722501,11.8146774 L17.3722501,11.8138574 C17.3155326,12.1476073 17.1996988,12.4682575 17.0287426,12.7585515 L17.0287426,13.9549961 C17.0287426,13.9984584 17.0527086,14.0369998 17.0902537,14.0558622 C18.3260789,14.6913894 19.4915543,15.4614201 20.566843,16.3527285 C20.8384464,16.579875 20.9974288,16.9201958 20.9998215,17.2802082 L21,17.2803628 Z" />
    </svg>
  ),
  trends: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M20.2849674,9.999518 L15.9993905,9.999518 C15.6721224,9.999518 15.3866816,10.222189 15.3071627,10.5402628 L14.1160723,15.3024767 L12.4236123,0.631823298 C12.3825972,0.282762849 12.0955085,0.0157334272 11.7447769,0.00066869057 C11.3940667,-0.0143988319 11.0843695,0.226682599 11.0140432,0.570728612 L8.75083005,11.8922104 L7.40320897,6.95427684 C7.32285441,6.65795369 7.06169135,6.44616878 6.75535832,6.42859682 C6.44816817,6.41018098 6.16442012,6.59098954 6.05057377,6.87642451 L4.80257093,9.999518 L1.71481279,9.999518 C1.31972546,9.999518 1,10.3192847 1,10.7135394 C1,11.1086512 1.31974689,11.4283965 1.71481279,11.4283965 L5.28555544,11.4283965 C5.57851748,11.4283965 5.84135191,11.250099 5.94932702,10.9788759 L6.58547805,9.38674966 L8.16745589,15.1876376 L8.16829287,15.1876376 C8.2528323,15.4981897 8.53490254,15.7141533 8.85715649,15.7141533 L8.88143,15.7141533 C9.21206226,15.7024341 9.49163186,15.4663888 9.5569012,15.1424219 L11.5239167,5.30255597 L13.1477432,19.3663341 L13.1477432,19.3671711 C13.1870827,19.7095457 13.4658187,19.9757179 13.8106791,19.9983257 L13.8567148,20 C14.1848185,19.9991628 14.4702594,19.7764933 14.5489426,19.4584195 L16.5578067,11.4282506 L20.2851872,11.4282506 C20.6802745,11.4282506 21,11.1084838 21,10.7133934 C21,10.3191388 20.6802531,9.99937207 20.2851872,9.99937207 L20.2849674,9.999518 Z" />
    </svg>
  ),
  insights: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M15.2402701,13.2637206 L15.2401879,13.2636964 C14.4978942,14.0051198 14.0946612,15.020334 14.1277144,16.0685725 C14.3656912,16.1044493 14.5413427,16.3103304 14.5385095,16.5520884 L14.5385095,19.017778 L14.4903465,19.017778 C14.280694,20.162357 13.285328,20.9952782 12.1209249,21 L10.0905447,21 C8.92614162,20.9952857 7.93077326,20.162357 7.72112316,19.017778 L7.67296014,19.017778 L7.67296014,16.5520884 C7.67013157,16.3235618 7.83445689,16.1280788 8.05921686,16.0921922 C8.08283661,15.0430593 7.69186561,14.0269022 6.97130597,13.2638656 C5.95800158,12.1853833 5.40366553,10.7546838 5.42444173,9.27485904 C5.47259992,7.80255296 6.07878387,6.40388637 7.12051899,5.36224795 C8.16225411,4.32060954 9.56087235,3.71433372 11.0331301,3.6661707 L11.105846,3.6661707 C12.5921741,3.67562343 14.0154275,4.2649085 15.0740615,5.30843263 C16.1317526,6.35089302 16.7418023,7.76650685 16.7729673,9.25198873 C16.803187,10.7375915 16.2535744,12.1767526 15.2402701,13.2637206 Z M7.67300366,12.5866048 L7.67287794,12.5867499 C8.55870334,13.5271884 9.04410936,14.7756991 9.02616656,16.0685483 L10.622156,16.0685483 L10.622156,12.9974967 C9.967693,12.77462 9.52384784,12.1655108 9.50968252,11.4751709 C9.50968252,10.5931169 10.2245609,9.87918145 11.105672,9.87918145 C11.9867831,9.87918145 12.7016614,10.5931411 12.7016614,11.4751709 C12.6874944,12.1655108 12.2436268,12.7746249 11.5891879,12.9974967 L11.5891879,16.0685483 L13.1606148,16.0685483 C13.1266236,14.7756508 13.6243066,13.5253027 14.5384418,12.6111675 C15.3638277,11.7348673 15.8218411,10.5752027 15.8199525,9.37112706 C15.8199525,8.11894163 15.3241552,6.91771877 14.4402397,6.0290648 C13.5573396,5.14137787 12.3579058,4.63990993 11.105672,4.6332993 L11.032956,4.6332993 C9.81766284,4.68051464 8.66459817,5.1847976 7.80427824,6.04511753 C6.9439583,6.90628362 6.439656,8.05937246 6.39149298,9.27476234 C6.36221609,10.5052137 6.82402217,11.6960652 7.67300366,12.5866048 Z M11.1057252,12.1030889 L11.1057445,12.1030696 C11.272896,12.1030696 11.4324852,12.0369633 11.5505308,11.9189177 C11.6676336,11.8008914 11.7346827,11.6412828 11.7346827,11.4750742 C11.7346827,11.1275471 11.4532522,10.8461167 11.1057252,10.8461167 C10.7581981,10.8461167 10.4767676,11.1275471 10.4767676,11.4750742 C10.4767676,11.8216584 10.7581981,12.1030889 11.1057252,12.1030889 Z M12.1209153,20.0329923 L12.1209636,20.0329923 C12.7527497,20.0301637 13.3099172,19.6203114 13.4987907,19.0178022 L8.71270801,19.0178022 C8.90156934,19.6203114 9.45874895,20.0301591 10.0905351,20.0329923 L12.1209153,20.0329923 Z M8.64008391,18.0507703 L13.5714631,18.0507703 L13.5714631,17.0355802 L8.64008391,17.0355802 L8.64008391,18.0507703 Z M11.5892411,1.65933774 C11.5892411,1.92659393 11.3729813,2.14285369 11.1057252,2.14285369 C10.838469,2.14285369 10.6222092,1.92660118 10.6222092,1.65933774 L10.6222092,-0.516484048 C10.6222092,-0.783740238 10.838469,-1 11.1057252,-1 C11.3729813,-1 11.5892411,-0.78374749 11.5892411,-0.516484048 L11.5892411,1.65933774 Z M20.7279344,7.75139698 C20.9951906,7.75139698 21.2114503,7.96765674 21.2114503,8.23491293 C21.2114503,8.50216912 20.9951978,8.71842888 20.7279344,8.71842888 L18.5521126,8.71842888 C18.2848564,8.71842888 18.0685966,8.50216912 18.0685966,8.23491293 C18.0685966,7.96765674 18.2848491,7.75139698 18.5521126,7.75139698 L20.7279344,7.75139698 Z M3.65933774,8.71842888 L1.48351595,8.71842888 C1.21625976,8.71842888 1,8.50216912 1,8.23491293 C1,7.96765674 1.21625251,7.75139698 1.48351595,7.75139698 L3.65933774,7.75139698 C3.92659393,7.75139698 4.14285369,7.96765674 4.14285369,8.23491293 C4.14285369,8.50216912 3.92660118,8.71842888 3.65933774,8.71842888 Z M4.14285369,2.38461167 C3.99836462,2.19195473 4.01820328,1.92281041 4.18818331,1.75282555 C4.35816334,1.58284068 4.62731733,1.56300685 4.81996943,1.70749593 L6.36683366,3.23076458 C6.53304227,3.43473579 6.53304227,3.72749261 6.36683366,3.9314759 C6.26295026,4.00985867 6.13546403,4.05235489 6.0041967,4.05235489 C5.88143683,4.04952148 5.76339125,4.00702527 5.66612234,3.9314759 L4.14285369,2.38461167 Z M18.0685966,1.70744757 L18.0686208,1.70747175 C18.1630563,1.79433539 18.2168861,1.91710976 18.2168861,2.04648896 C18.2168861,2.17491321 18.1630563,2.29768033 18.0686208,2.38456331 L16.5453521,3.93142755 C16.4480905,4.00697692 16.3300449,4.04947337 16.2072778,4.05230654 C16.0760105,4.05230654 15.9485218,4.00981032 15.8446408,3.93142755 C15.6784322,3.72745634 15.6784322,3.43469952 15.8446408,3.23071623 L17.3915051,1.70744757 C17.4783687,1.61301207 17.6011455,1.55918224 17.7295794,1.55918224 C17.8589465,1.55918224 17.9817136,1.61301207 18.0685966,1.70744757 Z" />
    </svg>
  ),
  designer: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M19.85158,1.2101431e-15 L1.99218,1.2101431e-15 C1.4453,1.2101431e-15 1,0.44532 1,0.99218 L1,18.85158 C1,19.39846 1.44532,19.84376 1.99218,19.84376 L19.85158,19.84376 C20.39846,19.84376 20.84376,19.39844 20.84376,18.85158 L20.84376,0.99218 C20.84376,0.4453 20.39844,0 19.85158,1.2101431e-15 Z M17.8672,1.98438 C18.41408,1.98438 18.85938,2.4297 18.85938,2.97656 C18.85938,3.52344 18.41406,3.96874 17.8672,3.96874 C17.32032,3.96874 16.87502,3.52342 16.87502,2.97656 C16.87502,2.42968 17.32034,1.98438 17.8672,1.98438 Z M13.8984,1.98438 C14.44528,1.98438 14.89058,2.4297 14.89058,2.97656 C14.89058,3.52344 14.44526,3.96874 13.8984,3.96874 C13.35152,3.96874 12.90622,3.52342 12.90622,2.97656 C12.90622,2.42968 13.35154,1.98438 13.8984,1.98438 Z M9.9296,1.98438 C10.47648,1.98438 10.92178,2.4297 10.92178,2.97656 C10.92178,3.52344 10.47646,3.96874 9.9296,3.96874 C9.38272,3.96874 8.93742,3.52342 8.93742,2.97656 C8.93742,2.42968 9.38274,1.98438 9.9296,1.98438 Z M18.8592,17.85938 L2.9842,17.85938 L2.9842,5.95318 L18.8592,5.95318 L18.8592,17.85938 Z" />
    </svg>
  ),
  lifesaver: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M18.0773784,3.92262162 C14.1805496,0.025792794 7.81945044,0.025792794 3.92262162,3.92262162 C0.025792794,7.81945044 0.025792794,14.1805496 3.92262162,18.0773784 C7.81945044,21.9742072 14.1805496,21.9742072 18.0773784,18.0773784 C21.9742072,14.1813921 21.9742072,7.81945044 18.0773784,3.92262162 Z M19.5090733,13.8226732 L16.3075651,12.7480753 C16.6868845,11.6109596 16.6868845,10.3676395 16.3075651,9.23060801 L19.5090733,8.15601007 C20.0990321,10.0106268 20.0990321,11.990279 19.5090733,13.8226311 L19.5090733,13.8226732 Z M2.49004202,8.17816933 L5.6915502,9.25276728 C5.31223078,10.389883 5.31223078,11.6332031 5.6915502,12.7702345 L2.49004202,13.8448325 C1.9000832,11.9902158 1.9000832,10.0105636 2.49004202,8.17821146 L2.49004202,8.17816933 Z M7.79794416,14.2020348 C6.02891026,12.4330009 6.02891026,9.54648285 7.79794416,7.7775332 C9.56697806,6.0084993 12.4534961,6.0084993 14.2224457,7.7775332 C15.9914796,9.5465671 15.9914796,12.4330851 14.2224457,14.2020348 C12.4320109,15.9718902 9.56689381,15.9718902 7.79794416,14.2020348 Z M13.8218096,2.49090564 L12.7472117,5.69241382 C11.6100959,5.3130944 10.3667758,5.3130944 9.22974439,5.69241382 L8.15514645,2.49090564 C10.0097631,1.90094682 11.9894154,1.90094682 13.8217675,2.49090564 L13.8218096,2.49090564 Z M8.17730571,19.5099369 L9.25190365,16.3084287 C10.3890194,16.6877482 11.6323395,16.6877482 12.7693709,16.3084287 L13.8439689,19.5099369 C11.9893522,20.0998957 10.0096999,20.0998957 8.17734784,19.5099369 L8.17730571,19.5099369 Z" />
    </svg>
  ),
  lock: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M18.1417811,21 L4.85712858,21 C4.38331597,21 4,20.6132993 4,20.1353029 L4,11.4014813 C4,10.9234848 4.38331597,10.5367841 4.85712858,10.5367841 L5.71425716,10.5367841 L5.71425716,6.83637347 C5.71425716,3.61306556 8.30422378,1 11.5004543,1 C14.6955491,1 17.2857428,3.6128364 17.2857428,6.83637347 L17.2857428,10.5367841 L18.1428714,10.5367841 C18.616684,10.5367841 19,10.9234848 19,11.4014813 L19,20.1343862 C19,20.6132764 18.6157981,20.9999771 18.1419855,20.9999771 L18.1417811,21 Z M14.5614396,7.00888209 C14.5614396,5.30274712 13.1905427,3.91985957 11.4994548,3.91985957 C9.808367,3.91985957 8.43747009,5.3028617 8.43747009,7.00888209 L8.43747009,10.5367383 L14.5625753,10.5367383 L14.5625753,7.00888209 L14.5614396,7.00888209 Z" />
    </svg>
  ),
  shield: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M11.0000696,1 C8.77451978,2.99273981 5.95654745,4.14687295 3,4.21652374 L3,14.7417648 C4.28668945,17.6441607 6.79064166,19.8117268 9.85188567,20.6858582 L11,21 L12.1481143,20.6503474 C15.2092888,19.8117408 17.7133801,17.6427761 19,14.7062541 L19,4.21667759 C16.0434526,4.11150909 13.2253411,2.99289366 10.9999304,1.00015385 L11.0000696,1 Z M13.5734485,14.8112757 L11.0000696,13.4468266 L8.42669067,14.8099121 L8.9130949,11.9075162 L6.82612023,9.8451256 L9.71338012,9.42582226 L11.0000696,6.80342813 L12.286759,9.42582226 L15.1740189,9.8451256 L13.0870442,11.9075162 L13.5734485,14.8112757 Z" />
    </svg>
  ),
  profile: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M13.6479555,15.2073287 C12.8538229,14.7808816 13.2776992,13.9819326 13.6479555,13.6094307 C14.1244351,13.1300613 14.7071378,11.4792409 14.7071378,11.4792409 C15.6600969,11.0527939 15.7663201,10.3607123 15.8715268,9.88134288 C16.295403,8.49615706 15.2362207,8.28344488 15.2362207,8.28344488 C15.2362207,8.28344488 16.0829566,5.9934653 15.3950472,4.2357775 C14.4946914,1.94579792 10.8416816,1.09290389 10.2063755,3.22411632 C5.86545622,2.26438043 6.76479549,8.28242223 6.76479549,8.28242223 C6.76479549,8.28242223 5.70561322,8.49514208 6.12948943,9.88032023 C6.23570498,10.3596896 6.34092691,11.0517712 7.29387838,11.4782182 C7.29387838,11.4782182 7.8765811,13.1290386 8.35306065,13.608408 C8.72331703,13.98091 9.14719324,14.779859 8.35306065,15.206306 C6.76479549,16.0581774 2,16.2719122 2,20 L20,20 C20.0009925,16.2719122 15.2362207,16.0592 13.6479555,15.2073287 Z" />
    </svg>
  ),
  switch: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path d="M8.16779338,10.5058732 C7.46699744,9.28754651 6.82148535,8.58404562 5.87228342,8.58404562 L2.00009284,8.58404562 L2.00009284,6.74219169 L5.87321178,6.74219169 C7.37179409,6.74219169 8.39261902,7.56699853 9.1886183,8.66401922 C8.79696633,9.27675916 8.46607552,9.91827303 8.16779338,10.5058732 Z M15.3454106,14.4169204 L15.3454106,12.6748667 L19.9990484,15.3378934 L15.3444823,18 L15.3444823,16.2587743 L13.6146918,16.2587743 C12.1161095,16.2587743 11.0952846,15.4339675 10.2992853,14.3369468 C10.6909373,13.7242069 11.0209229,13.082693 11.3201102,12.4950929 C12.0209062,13.7134195 12.6664182,14.4169204 13.6156202,14.4169204 L15.3454106,14.4169204 Z M13.6156434,8.58393062 L13.6156434,8.58397662 C12.3463196,8.58397662 11.6192279,9.84099052 10.5757278,11.9119549 C9.54756879,13.9505112 8.38247668,16.2586363 5.87219058,16.2586363 L2,16.2586363 L2,14.4167824 L5.87219058,14.4167824 C7.14151434,14.4167824 7.86860608,13.1588715 8.9121062,11.0888041 C9.94026518,9.05024779 11.1053573,6.74212269 13.6156434,6.74212269 L15.3454338,6.74212269 L15.3454338,5 L20,7.66302665 L15.3454338,10.3260533 L15.3454338,8.58393062 L13.6156434,8.58393062 Z" />
    </svg>
  ),

  sparkpostLeftButton: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
    >
      <g fill="none" fillRule="evenodd">
        <circle cx="18" cy="18" r="18" fill="#FA6423" />
        <polygon
          fill="#FFF"
          fillRule="nonzero"
          points="27 15.875 13.309 15.875 19.598 9.586 18 8 9 17 18 26 19.586 24.414 13.309 18.125 27 18.125"
        />
      </g>
    </svg>
  ),
  sparkpostCode: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="23"
      viewBox="0 0 24 23"
    >
      <path d="M9.14,16.66 L4.08,11.6 L9.14,6.54 L7.6,5 L1,11.6 L7.6,18.2 L9.14,16.66 Z M14.86,16.66 L19.92,11.6 L14.86,6.54 L16.4,5 L23,11.6 L16.4,18.2 L14.86,16.66 Z" />
    </svg>
  ),
  sparkpostContactCard: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="23"
      viewBox="0 0 24 23"
    >
      <path d="M18.4,3.8 L17.5,3.8 L17.5,2 L15.7,2 L15.7,3.8 L8.5,3.8 L8.5,2 L6.7,2 L6.7,3.8 L5.8,3.8 C4.801,3.8 4,4.61 4,5.6 L4,18.2 C4,19.19 4.801,20 5.8,20 L18.4,20 C19.39,20 20.2,19.19 20.2,18.2 L20.2,5.6 C20.2,4.61 19.39,3.8 18.4,3.8 Z M12.1,6.5 C13.594,6.5 14.8,7.706 14.8,9.2 C14.8,10.694 13.594,11.9 12.1,11.9 C10.606,11.9 9.4,10.694 9.4,9.2 C9.4,7.706 10.606,6.5 12.1,6.5 Z M17.5,17.3 L6.7,17.3 L6.7,16.4 C6.7,14.6 10.3,13.61 12.1,13.61 C13.9,13.61 17.5,14.6 17.5,16.4 L17.5,17.3 Z" />
    </svg>
  ),
  sparkpostSend: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="23"
      viewBox="0 0 24 23"
    >
      <polygon points="3.009 20 21.667 12 3.009 4 3 10.222 16.333 12 3 13.778" />
    </svg>
  ),
  // sparkpostCode: (<svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14"><path fill="#FFF" d="M15.14,24.66 L10.08,19.6 L15.14,14.54 L13.6,13 L7,19.6 L13.6,26.2 L15.14,24.66 Z M20.86,24.66 L25.92,19.6 L20.86,14.54 L22.4,13 L29,19.6 L22.4,26.2 L20.86,24.66 Z" transform="translate(-7 -13)"/></svg>),
  // sparkpostContactCard: (<svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18"><path fill="#FFF" d="M24.4,11.8 L23.5,11.8 L23.5,10 L21.7,10 L21.7,11.8 L14.5,11.8 L14.5,10 L12.7,10 L12.7,11.8 L11.8,11.8 C10.801,11.8 10,12.61 10,13.6 L10,26.2 C10,27.19 10.801,28 11.8,28 L24.4,28 C25.39,28 26.2,27.19 26.2,26.2 L26.2,13.6 C26.2,12.61 25.39,11.8 24.4,11.8 Z M18.1,14.5 C19.594,14.5 20.8,15.706 20.8,17.2 C20.8,18.694 19.594,19.9 18.1,19.9 C16.606,19.9 15.4,18.694 15.4,17.2 C15.4,15.706 16.606,14.5 18.1,14.5 Z M23.5,25.3 L12.7,25.3 L12.7,24.4 C12.7,22.6 16.3,21.61 18.1,21.61 C19.9,21.61 23.5,22.6 23.5,24.4 L23.5,25.3 Z" transform="translate(-10 -10)"/></svg>),
  // sparkpostSend: (<svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16"><polygon points="12.009 28 30.667 20 12.009 12 12 18.222 25.333 20 12 21.778" transform="translate(-12 -12)"/></svg>)

  // drift exit
  dblChat: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="19"
      viewBox="0 0 22 19"
    >
      <path
        fill="#111"
        d="M18.7644445,25.5885368 L25.8825302,25.5885368 C27.8470603,25.5885368 29.4412431,23.995256 29.4412431,22.0307039 L29.4412431,18.4711111 L30.4106052,18.4711111 C31.8406023,18.4711111 33,19.6312567 33,21.0620459 L33,25.9088562 C33,27.3397113 31.8415703,28.499791 30.4114852,28.499791 L30.4114852,30.1179978 C30.4114852,30.6413547 29.8228104,30.9481441 29.3939872,30.6482407 L26.3252133,28.499813 L21.3512433,28.499813 C19.9229622,28.499813 18.7644885,27.3405253 18.7644885,25.9121782 L18.7644445,25.5885368 Z M13.5885148,24.6182948 C12.1585177,24.6174354 11,23.4598651 11,22.0306599 L11,14.5876348 C11,13.1593537 12.1601457,12 13.5900548,12 L25.8798902,12 C27.3107454,12 28.4699451,13.1584297 28.4699451,14.5876348 L28.4699451,22.0306599 C28.4699451,23.4589411 27.3115154,24.6182948 25.8823102,24.6182948 L18.2923254,24.6182948 L14.5609129,26.7942224 C14.1295157,27.0460119 13.5880968,26.7349259 13.5880968,26.2356215 L13.5885148,24.6182948 Z M19.7355225,19.4414851 C20.2709135,19.4414851 20.7057646,19.007492 20.7057646,18.4712431 C20.7057646,17.9349941 20.2709135,17.500143 19.7355225,17.500143 C19.1992736,17.500143 18.7644225,17.9349941 18.7644225,18.4712431 C18.7644225,19.007492 19.1992736,19.4414851 19.7355225,19.4414851 Z M22.9701761,19.4414851 C23.506425,19.4414851 23.9412761,19.007492 23.9412761,18.4712431 C23.9412761,17.9349941 23.506425,17.500143 22.9701761,17.500143 C22.4347851,17.500143 21.999934,17.9349941 21.999934,18.4712431 C21.999934,19.007492 22.4347851,19.4414851 22.9701761,19.4414851 Z M16.499989,19.4414851 C17.0362379,19.4414851 17.4702311,19.007492 17.4702311,18.4712431 C17.4702311,17.9349941 17.0362379,17.500143 16.499989,17.500143 C15.9637401,17.500143 15.5297469,17.9349941 15.5297469,18.4712431 C15.5297469,19.007492 15.9637401,19.4414851 16.499989,19.4414851 Z"
        transform="translate(-11 -12)"
      />
    </svg>
  ),
  playbook: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="23"
      viewBox="0 0 17 23"
    >
      <path
        d="M17.1556567,96.005254 C17.0346423,96.1262684 16.8654157,96.1990658 16.6961892,96.1990658 C16.5269626,96.1990658 16.357736,96.1262684 16.2367216,96.005254 C15.9946928,95.7632251 15.9946928,95.3519697 16.2367216,95.0853508 L17.3258514,93.996221 L16.2367216,92.9070913 C15.9946928,92.6650624 15.9946928,92.253807 16.2367216,91.9871881 C16.4787505,91.7451592 16.8900059,91.7451592 17.1566248,91.9871881 L18.2457546,93.0763178 L19.3348843,91.9871881 C19.5769132,91.7451592 19.9881686,91.7451592 20.2547875,91.9871881 C20.4968164,92.2292169 20.4968164,92.6404723 20.2547875,92.9070913 L19.1401237,93.996221 L20.2292535,95.0853508 C20.4712823,95.3273796 20.4712823,95.738635 20.2292535,96.005254 C20.1082391,96.1262684 19.9390125,96.1990658 19.769786,96.1990658 C19.6005546,96.1990658 19.4313328,96.1262684 19.3103184,96.005254 L18.2211887,94.9161242 L17.1556567,96.005254 Z M28.8940552,90.8979615 C29.0150696,91.0189759 29.1842962,91.0917733 29.3535228,91.0917733 C29.5227493,91.0917733 29.6919759,91.0189759 29.8129903,90.8979615 C30.0550191,90.6559326 30.0550191,90.2446773 29.8129903,89.9780583 L28.7002143,88.9135187 L29.7893441,87.8243889 C30.0313729,87.5823601 30.0313729,87.1711047 29.7893441,86.9044857 C29.5473153,86.6624569 29.1360599,86.6624569 28.8694409,86.9044857 L27.7803111,87.9936155 L26.6911814,86.9044857 C26.4491525,86.6624569 26.0378971,86.6624569 25.7712782,86.9044857 C25.5292493,87.1465145 25.5292493,87.5577699 25.7712782,87.8243889 L26.8604079,88.9135187 L25.7712782,90.0026484 C25.5292493,90.2446773 25.5292493,90.6559326 25.7712782,90.9225516 C25.8922926,91.043566 26.0615192,91.1163635 26.2307457,91.1163635 C26.3999771,91.1163635 26.5691988,91.043566 26.6902133,90.9225516 L27.779343,89.8334219 L28.8940552,90.8979615 Z M31.2169754,95.1097473 L32.3061051,94.0206175 C32.548134,93.7785887 32.548134,93.3673333 32.3061051,93.1007143 C32.0640763,92.8586855 31.6528209,92.8586855 31.3862019,93.1007143 L30.2970722,94.1898441 L29.2079424,93.1007143 C28.9659136,92.8586855 28.5546582,92.8586855 28.2880392,93.1007143 C28.0460104,93.3427432 28.0460104,93.7539986 28.2880392,94.0206175 L29.377169,95.1097473 L28.2880392,96.198877 C28.0460104,96.4409059 28.0460104,96.8521613 28.2880392,97.1187802 C28.4090536,97.2397947 28.5782802,97.3125921 28.7475068,97.3125921 C28.9167382,97.3125921 29.0859599,97.2397947 29.2069743,97.1187802 L30.2961041,96.0296505 L31.3852338,97.1187802 C31.5062482,97.2397947 31.6754748,97.3125921 31.8447014,97.3125921 C32.0139279,97.3125921 32.1831545,97.2397947 32.3041689,97.1187802 C32.5461977,96.8767514 32.5461977,96.465496 32.3041689,96.198877 L31.2169754,95.1097473 Z M22.6249517,101.668245 C22.6249517,103.241432 21.3420053,104.49974 19.7934564,104.49974 C18.2449075,104.49974 16.961961,103.216794 16.961961,101.668245 C16.961961,100.119647 18.2203174,98.8367493 19.7934564,98.8367493 C21.3665954,98.8367493 22.6249517,100.119696 22.6249517,101.668245 Z M21.3183833,101.668245 C21.3183833,100.821144 20.6168869,100.119647 19.769786,100.119647 C18.922685,100.119647 18.2211887,100.821144 18.2211887,101.668245 C18.2211887,102.515346 18.922685,103.216842 19.769786,103.216842 C20.615943,103.217787 21.3183833,102.539912 21.3183833,101.668245 Z M19.212926,83.516082 L21.9962576,84.2667586 C22.213706,84.3149756 22.407513,84.1939612 22.4803153,84.0001397 C22.5285323,83.7826913 22.4075179,83.5888843 22.2136963,83.516082 L18.5104131,82.5243204 C18.4858327,82.5243204 18.4621961,82.5243204 18.4376157,82.49974 L18.4130352,82.49974 L18.3648182,82.49974 L18.3166013,82.49974 L18.2920208,82.49974 C18.2438038,82.5243204 18.1955868,82.547957 18.1710064,82.5725374 L18.1464259,82.5971179 C18.1218455,82.6216983 18.1218455,82.6216983 18.1218455,82.6453349 L18.0972651,82.6699153 L18.0726846,82.6944958 C18.0726846,82.7190762 18.0481042,82.7427127 18.0481042,82.7672932 L17.1045789,86.3013982 C17.056362,86.5188466 17.1773764,86.7126536 17.3711979,86.7854559 C17.3957784,86.7854559 17.4439953,86.8100364 17.4676319,86.8100364 C17.6368633,86.8100364 17.806085,86.689022 17.8306751,86.5197954 L18.5321715,83.9056419 L24.8249212,94.8451033 L22.4774351,98.1606563 C22.3564207,98.3298877 22.4046377,98.5719117 22.5738691,98.6929261 C22.6466665,98.7411431 22.719464,98.7657235 22.7913175,98.7657235 C22.9123319,98.7657235 23.0333463,98.7175065 23.1061486,98.5964921 L25.5992876,95.087074 C25.6957216,94.9660596 25.6957216,94.796833 25.6238681,94.6758186 L19.212926,83.516082 Z"
        transform="translate(-16 -82)"
      />
    </svg>
  ),
  personD: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
    >
      <path
        fill="#111"
        fillRule="evenodd"
        d="M205.524173,25.5953489 C204.641803,25.1243753 205.112777,24.2420058 205.524173,23.8306098 C206.053595,23.3011881 206.701042,21.4780008 206.701042,21.4780008 C207.759886,21.0070273 207.877911,20.2426835 207.994808,19.7132618 C208.465781,18.1834447 207.288912,17.9485227 207.288912,17.9485227 C207.288912,17.9485227 208.22973,15.4194398 207.465386,13.4782268 C206.464991,10.9491439 202.406091,10.0071968 201.700195,12.3609352 C196.876951,11.3009905 197.876217,17.9473932 197.876217,17.9473932 C197.876217,17.9473932 196.699348,18.1823238 197.170322,19.7121323 C197.288339,20.241554 197.405252,21.0058978 198.464087,21.4768714 C198.464087,21.4768714 199.111535,23.3000586 199.640956,23.8294804 C200.052352,24.2408763 200.523326,25.1232459 199.640956,25.5942195 C197.876217,26.5350372 192.582,26.7710887 192.582,30.8884367 L212.582,30.8884367 C212.583103,26.7710887 207.288912,26.5361666 205.524173,25.5953489 Z"
        transform="translate(-192 -11)"
      />
    </svg>
  ),

  // crazy egg exit
  recordings: (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>recordings-icon_BETA Copy</title>
      <desc>Created with Sketch.</desc>
      <g
        id="recordings-icon_BETA-Copy"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M20,7.2198039 L15,8.2198039 L15,6 L2,6 L2,16 L15,16 L15,13.7801961 L20,14.7801961 L20,7.2198039 Z"
          id="Combined-Shape"
          stroke="#0086E6"
          strokeWidth="2"
        />
      </g>
    </svg>
  ),
  snapshots: (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>snapshot-icon_BETA</title>
      <desc>Created with Sketch.</desc>
      <g
        id="snapshot-icon_BETA"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      >
        <path
          d="M15.3177951,18 C14.3674888,18.6318473 13.2267377,19 12,19 C10.7732623,19 9.63251117,18.6318473 8.68220488,18 L1,18 C0.44771525,18 6.76353751e-17,17.5522847 0,17 L0,4 C-6.76353751e-17,3.44771525 0.44771525,3 1,3 L8,3 C8,2.44771525 8.44771525,2 9,2 L14,2 C14.5522847,2 15,2.44771525 15,3 L21,3 C21.5522847,3 22,3.44771525 22,4 L22,17 C22,17.5522847 21.5522847,18 21,18 L15.3177951,18 Z M17.1973068,16 L20,16 L20,5 L13,5 L13,4 L10,4 L10,5 L2,5 L2,16 L6.80269317,16 C6.29218286,15.1174799 6,14.0928614 6,13 C6,9.6862915 8.6862915,7 12,7 C15.3137085,7 18,9.6862915 18,13 C18,14.0928614 17.7078171,15.1174799 17.1973068,16 Z M12,17 C14.209139,17 16,15.209139 16,13 C16,10.790861 14.209139,9 12,9 C9.790861,9 8,10.790861 8,13 C8,15.209139 9.790861,17 12,17 Z M5,8 C4.44771525,8 4,7.55228475 4,7 C4,6.44771525 4.44771525,6 5,6 C5.55228475,6 6,6.44771525 6,7 C6,7.55228475 5.55228475,8 5,8 Z"
          fill="#0086E6"
        />
      </g>
    </svg>
  ),
  abtests: (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>abtest-icon-v3_BETA</title>
      <desc>Created with Sketch.</desc>
      <g
        id="abtest-icon-v3_BETA"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      >
        <path
          d="M16,7 L19,7 C19.5522847,7 20,7.44771525 20,8 L20,19 C20,19.5522847 19.5522847,20 19,20 L8,20 C7.44771525,20 7,19.5522847 7,19 L7,16 L9,16 L9,18 L18,18 L18,9 L16,9 L16,7 Z M2,1 L13,1 C13.5522847,1 14,1.44771525 14,2 L14,13 C14,13.5522847 13.5522847,14 13,14 L2,14 C1.44771525,14 1,13.5522847 1,13 L1,2 C1,1.44771525 1.44771525,1 2,1 Z M3,3 L3,12 L12,12 L12,3 L3,3 Z"
          id="Combined-Shape"
          fill="#0086E6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  teammembers: (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>team-icon-v1_BETA</title>
      <desc>Created with Sketch.</desc>
      <g
        id="team-icon-v1_BETA"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      >
        <path
          d="M0,14.0574984 L0,16.245106 L6.39397201,16.245106 L6.39397201,18 L15.606028,18 L15.606028,16.2210664 L22,16.2210664 L22,14.0574984 C21.987233,11.8151933 20.2066212,9.99694779 17.9978471,9.97075902 C19.4832737,9.65653988 20.4941289,8.25303618 20.3385407,6.72086544 C20.1829524,5.1886947 18.9113068,4.02403964 17.393972,4.02403964 C15.8766373,4.02403964 14.6049916,5.1886947 14.4494034,6.72086544 C14.2938151,8.25303618 15.3046703,9.65653988 16.7900969,9.97075902 C15.3217911,9.99350745 13.9806762,10.8213883 13.285253,12.1343269 C12.7680405,11.8787515 12.2026328,11.7393609 11.6275565,11.725653 C13.112983,11.4114339 14.1238383,10.0079302 13.96825,8.47575943 C13.8126618,6.94358869 12.5410161,5.77893363 11.0236814,5.77893363 C9.50634664,5.77893363 8.234701,6.94358869 8.07911272,8.47575943 C7.92352445,10.0079302 8.93437971,11.4114339 10.4198062,11.725653 C9.8384799,11.7283811 9.26471736,11.8596359 8.73842842,12.1102873 C8.04300514,10.7973486 6.70189031,9.96946781 5.2335845,9.94671937 C6.71901104,9.63250024 7.7298663,8.22899654 7.57427802,6.6968258 C7.41868974,5.16465506 6.1470441,4 4.62970936,4 C3.11237463,4 1.84072899,5.16465506 1.68514071,6.6968258 C1.52955243,8.22899654 2.54040769,9.63250024 4.02583423,9.94671937 C1.79860221,9.95994139 -3.80850354e-05,11.7965329 0,14.0574984 Z M14.1851453,16.5576214 L7.83853606,16.5576214 L7.83853606,15.8123924 C7.85139169,14.3573921 9.01017135,13.1810817 10.4434876,13.1680316 L11.5801938,13.1680316 C13.01351,13.1810817 14.1722897,14.3573921 14.1851453,15.8123924 L14.1851453,16.5576214 Z M15.8665231,7.03792249 C15.856912,6.40382268 16.2257928,5.82671401 16.8001579,5.57726418 C17.3745231,5.32781436 18.0404453,5.45550266 18.4856026,5.90044245 C18.93076,6.34538223 19.066854,7.01931808 18.8300556,7.60616972 C18.5932573,8.19302135 18.0305364,8.57638463 17.4058127,8.57645968 C16.564949,8.56332606 15.890105,7.86756865 15.8902045,7.01388284 L15.8665231,7.03792249 Z M16.8374596,11.4131376 L17.9741658,11.4131376 C19.407482,11.4261878 20.5662617,12.6024981 20.5791173,14.0574984 L20.5791173,14.8027274 L15.4876211,14.8027274 C15.3106839,14.1141071 14.9596711,13.4843268 14.4693219,12.9757145 C14.8891292,12.0147566 15.8256025,11.3935457 16.861141,11.389098 L16.8374596,11.4131376 Z M9.47255113,8.76877683 C9.47255113,7.90578947 10.1617145,7.20619999 11.0118407,7.20619999 C11.8619668,7.20619999 12.5511302,7.90578947 12.5511302,8.76877683 C12.5511302,9.63176419 11.8619668,10.3313537 11.0118407,10.3313537 C10.1617145,10.3313537 9.47255113,9.63176419 9.47255113,8.76877683 Z M3.07857912,7.01388284 C3.07857912,6.15089549 3.76774253,5.45130601 4.61786868,5.45130601 C5.46799482,5.45130601 6.15715823,6.15089549 6.15715823,7.01388284 C6.15715823,7.8768702 5.46799482,8.57645968 4.61786868,8.57645968 C4.2096237,8.57645968 3.81809938,8.41183152 3.52942659,8.11879152 C3.2407538,7.82575152 3.07857912,7.42830399 3.07857912,7.01388284 Z M1.42088267,14.0574984 C1.4337383,12.6024981 2.59251796,11.4261878 4.02583423,11.4131376 L5.16254037,11.4131376 C6.19253235,11.4133242 7.12751601,12.0241495 7.55435953,12.9757145 C7.06401024,13.4843268 6.71299746,14.1141071 6.53606028,14.8027274 L1.42088267,14.8027274 L1.42088267,14.0574984 Z"
          id="Shape"
          fill="#0086E6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  loaderSW6: (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="currentColor"
        strokeWidth="6"
        r="24"
        strokeDasharray="113.09733552923255 39.69911184307752"
        transform="rotate(132 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
};

export default icons;
